

import React from 'react';
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import Network from '../../Utils/network.js';
import { Tooltip, Button, Modal, ModalBody } from 'reactstrap';
import { FaPlus } from 'react-icons/fa';
import Swal from 'sweetalert2';
import BillAccount from '../../ImageAssets/BillAccount.png';
import SwitchAccount from '../../ImageAssets/switchAccountNew.png';
import Recharge from '../../ImageAssets/Recharge.png';
import SliderModal from '../../Utils/sliderModal.js';
import GeneralUtils from '../../Utils/generalUtils.js';
import ValidateForm from '../../Utils/formValidation';
import { setCache, setSwitchAccountModalTrue, setCurrentPage, setfeasibilityResposne, setRegisterDetails } from '../../General/Actions.js';
import phone from '../../ImageAssets/phoneCall.png';
import phoneDisabled from '../../ImageAssets/phoneCallDisabled.png';
import infoIcon from '../../ImageAssets/infoIcon.png';
import ActivateAddonRootComponent from './ActivateAddon/ActivateAddonRootComponent';
import MyAccountComponent from './MyAccountComponent';
import RechargeComponent from './RechargeComponent';
import ReceiptComponent from '../../Utils/receiptModal';
import FriendsAndFamilyComponent from './FriendsAndFamilyPart';
import "react-toggle/style.css";
import { IoMdClose } from 'react-icons/io';
import moment from 'moment';
import SettingsAccount from '../../ImageAssets/SettingsAccount.png';
import Support from '../../ImageAssets/Support.png';
import Constants from '../../Utils/constants.json';
import TableComponent from '../../Utils/tableComponent.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import searchIcon from '../../ImageAssets/searchIcon.svg';
import NoDataFound from '../../Utils/noDataFound.js';
import Switch from 'react-toggle-switch';
import viewIcon from '../../ImageAssets/viewIcon.png';
import Toggle from 'react-toggle';
import "react-toggle/style.css";


class MyAccountVoicePartComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hardCodedServiceNameForInternalUse: "Voice",
            skeltonScreenLoading: false,
            isLoading: true,
            isServiceFeasible: false,
            userDetails: {},
            firstName: "NA",
            lastName: "NA",
            profileId: "NA",
            currentPlanId: "",
            currentPlanName: "",
            activePlanName: "",
            activePlanDesc: "",
            activePlanAmount: "",
            discountAmount: "",
            basePlanPrice: 0,
            discountName: "Discount",
            allDevices: [],
            activationDate: "",
            activePlanDecimal: "",
            activeaddOnDecAmt: "",
            allDevicesArray: [],
            devicesArray: [],
            currentService: [],
            allServicesCharge: 0,
            reasonForSuspension: [],
            addDeviceStatus: 1,
            addAddonsStatus: 1,
            changePlanStatus: 1,
            settingsStatus: 1,
            rechargeStatus: 1,
            billsAndPaymentStatus: 1,
            serviceCenterStatus: 1,
            serviceContractDateFrom: "",
            serviceContractDateTo: "",
            isPriceInfoTooltipOpen: false,
            redirectToMyAccount: false,
            basePlanArray: [],
            isCallMeBackModalVisible: false,
            callMeBackVal: "",
            isRechargeComponentVisible: false,
            isReceiptModalVisible: false,
            transactionId: "",
            finalRechargeAmount: 0,
            isFriendsAndFamilySectionVisible: false,
            isDndInfoTooltipOpen: false,
            isPopupVisible: false,
            popupContent: "",
            redirectToAddSubscription: false,
            benefits: [],
            serviceCode: "",
            isContractExpired: true,
            loanAmount: "",
            isPrepaidService: false,
            isRewardInfoTooltipOpen: false,
            isRewardInfoTooltipOpenInSlider: false,
            rewardPointsFromLMS: 0,
            fnfAddonObj: {},
            isViewUsageInfoModalVisible: false,
            receivedUsageAddonId: "",
            allAddonArray: [],
            connectionType: "1",
            planId: "",
            transactionHistoryPayload: {},
            isQueryPlanCallRequired: true,
            transactionValuesArray: [],
            isLoyaltySliderVisible: false,
            tab: "transfer",
            loyaltyTransferTab: true,
            transactionHistoryTab: false,
            rangeVal: 1,
            transactionHistoryDateFrom: new Date(),
            transactionHistoryDateTo: new Date(),
            offsetForTransactionHistory: 1,
            loyaltyTransactionsPayload: {
                totalRecords: -1,
                data: []
            },
            isAlreadyRegisteredForRewards: false,
            rewardsTermsAndConditionsVisible: false,
            redeemRewardsModalVisible: false,
            transactionsRewardsModalVisible: false,
            planIdForFnF: "",
            activationDateForFnF: "",
            isFnFAdded: "false",
            rewardsTransactionsData: {
                totalRecords: -1,
                data: []
            },
            isFirstTimeLoading: true,
            allAddonDetails: [],
            basePlanDetailsObj: {},
            addonSearchName: "",
            serviceTypeTypeArray: [],
            serviceType: "ALL",
            transactionHistorySliderArr: [],
            isTransactionHistoryModalVisible: false,
            selfcareBucketNames: [],
            payGoStatus: false,
            enablePayGo: "false"
        }
    }

    componentWillMount() {
        for (var i = 0; i < this.props.cache.serviceListResponse.length; i++) {
            let currentService = this.props.cache.serviceListResponse[i];
            if ((currentService.service_id) === this.props.currentServiceDetails.currentServiceId) {
                this.setState({
                    userDetails: currentService,
                    // skeltonScreenLoading: false
                });
            }
        }
    }

    allUsageInfoClicked = (receivedId, receivedType,event) => {
        event.stopPropagation();
        this.setState({ isViewUsageInfoModalVisible: true }, () => {
            document.addEventListener("click", this.closeMenu);
        });
        this.setState({isViewUsageInfoModalVisible : true, receivedUsageAddonId: receivedId,bucketDetailsType: receivedType })
    }
    
    closeMenu = () => {
        this.setState({ isViewUsageInfoModalVisible: false }, () => {
          document.removeEventListener("click", this.closeMenu);
        });
    };

    manageFeatures() {        // 1-show feature   0-hide feature
        var addDeviceStatus = 1;
        var addAddonsStatus = 1;
        var changePlanStatus = 1;
        var serviceCenterStatus = 1;
        var billsAndPaymentStatus = 1;
        var settingsStatus = 1;
        var rechargeStatus = 1;
        var features = this.props.userDetails.features;
        if (features.length > 0) {
            for (var i = 0; i < features.length; i++) {
                if (features[i].featureName === "AddDevice") {
                    addDeviceStatus = features[i].status;
                } else if (features[i].featureName === "AddAddons") {
                    addAddonsStatus = features[i].status;
                } else if (features[i].featureName === "ChangePlan") {
                    changePlanStatus = features[i].status;
                } else if (features[i].featureName === "ViewServiceCenter") {
                    serviceCenterStatus = features[i].status;
                } else if (features[i].featureName === "ViewBillsAndPayments") {
                    billsAndPaymentStatus = features[i].status;
                } else if (features[i].featureName === "Settings") {
                    settingsStatus = features[i].status;
                } else if (features[i].featureName === "recharge") {
                    rechargeStatus = features[i].status;
                }
            }
        }
        this.setState({
            addDeviceStatus: addDeviceStatus,
            addAddonsStatus: addAddonsStatus,
            changePlanStatus: changePlanStatus,
            rechargeStatus: rechargeStatus,
            settingsStatus: settingsStatus,
            billsAndPaymentStatus: billsAndPaymentStatus,
            serviceCenterStatus: serviceCenterStatus
        })
    }

    componentDidMount() {
        var serviceTypeTypeArray = [];
        var serviceType = "ALL";
        var selfcareBucketNames = [];
        var enablePayGo = "false"
        Network.executeAxios("fetchSelfcareBucketInfo", "POST", {} , (bucketInfoResp) => {
            if(bucketInfoResp && bucketInfoResp[0]) selfcareBucketNames = bucketInfoResp
            if (this.props.configurationValues) {
                serviceTypeTypeArray = this.props.configurationValues.serviceTypeForTransactionHistory
                enablePayGo = this.props.configurationValues.enablePayGo
            }
            console.log("enablePayGo",enablePayGo)
            if(serviceTypeTypeArray && serviceTypeTypeArray.length > 0)
            serviceType = serviceTypeTypeArray[0].id
            this.initialiseQuerySubscriber();
            this.setState({
                enablePayGo: enablePayGo,
                serviceType: serviceType,
                serviceTypeTypeArray: serviceTypeTypeArray,
                selfcareBucketNames: selfcareBucketNames
            },() => {
                this.loadComponentDidMount();
            });
        })
    }

    initialiseQuerySubscriber(){
        var reduxCache = this.props.cache;
        var maBalance = "0";
        var serviceCode = ""
        var serviceName = ""
        try {
            var receivedResponse = reduxCache.querySubscriberResponse;
            var params = receivedResponse.profile_info.basic_details;
            var finalContactNumber = "";
            var finalFirstName = "";
            var finalLastName = "";
            
            for (var i = 0; i < params.length; i++) {
                if (params[i].id === "first_name") {
                    finalFirstName = params[i].value;
                }
                if (params[i].id === "last_name") {
                    finalLastName = params[i].value;
                }
                if (params[i].id === "contact_number_1") {
                    finalContactNumber = params[i].value;
                }
            }
            this.setState({
                contactNumber: finalContactNumber,
                customerName: finalFirstName+ " "+ finalLastName
            })

        } catch (err) {

        }
    }

    loadComponentDidMount() {
        this.state.allServicesCharge = 0;
        this.setState({ isLoading: true })
        this.manageFeatures();
        //this.initialiseRewardPoints(); // old flow not using
        this.initialiseServiceAddress();


        // this.setState({
        //     callMeBackVal:this.getUrlParameter("mobileNumber")
        // },() => {
        //     this.handleContactNumberOnBlur();
        // });

        Network.executeAxios("fetchHlrStatus", "POST", {"serviceId": this.props.currentServiceDetails.currentServiceId} , (HLRstatusResponse) => {
            this.manageHlrStatus(HLRstatusResponse);
            var dataToSend = {
            serviceId: this.props.currentServiceDetails.currentServiceId,
            basePlanOrAddon: "basePlan"
        }
            Network.executeAxios("fetchContractDetails", "POST", dataToSend, (contractDetailsResponse) => {
                this.populateContractDetails(contractDetailsResponse)
                localStorage.setItem("currentServiceId", this.props.currentServiceDetails.currentServiceId);
                this.initialiseSubscriberInfo();
                this.getRewardPoints();
            })
        })

    }

    manageHlrStatus(receivedResponse, isLoadingChangeReq){
        if(receivedResponse && receivedResponse.responseData){
            var receivedDataFromRes = receivedResponse.responseData;
            if(receivedDataFromRes["CFNRY"] === "true" && receivedDataFromRes["CFB"] === "true" && receivedDataFromRes["CFNRC"] === "true")
            this.setState({notificationVoice: true})
            else this.setState({notificationVoice: false})
            if(isLoadingChangeReq) this.setState({isLoading: false})
        }
    }

    getRewardPoints() {
        Network.executeAxios("getRewardsData", "POST", { "serviceId": this.state.userDetails.service_id }, (rewardsData) => {
            if (rewardsData.result_code === "0") {  // user already registered in lms
                this.setState({ isAlreadyRegisteredForRewards: true })
                if (rewardsData && rewardsData.loyalty_info && rewardsData.loyalty_info.rewardPoints) {
                    this.setState({ rewardPointsFromLMS: rewardsData.loyalty_info.rewardPoints })
                    console.log("Total Rewards points >> ", rewardsData.loyalty_info.rewardPoints)
                    console.log("Loyality ID >> ", rewardsData.loyalty_info.loyaltyID)
                    Network.executeAxios("getRewardsTransactions", "POST", { "serviceId": this.state.userDetails.service_id, "loyalityId": rewardsData.loyalty_info.loyaltyID }, (rewardsTransactions) => {
                        console.log("popuplate rewards transactions >> ", rewardsTransactions)
                        var rewardsTransactionsDataArr = [];
                        var payLoadForTransactions = {
                            totalRecords: 0,
                            data: ""
                        }
                        if (rewardsTransactions && rewardsTransactions.result_code == 0) {
                            rewardsTransactionsDataArr = rewardsTransactions.loyalty_information.redemption_details
                        }

                        for(var k=0; k<rewardsTransactionsDataArr.length; k++){
                            var currentObj = rewardsTransactionsDataArr[k];
                            if(currentObj.date){
                                currentObj["date"] = GeneralUtils.formatDateToStandardForm(currentObj.date,"DD-MM-YYYY hh:mm:ss","MM/DD/YYYY")
                            }
                            if(currentObj.expiry_date){
                                currentObj["expiry_date"] = GeneralUtils.formatDateToStandardForm(currentObj.expiry_date,"YYYY-MM-DD hh:mm:ss","MM/DD/YYYY")
                            }
                        }

                        payLoadForTransactions = {
                            totalRecords: rewardsTransactionsDataArr.length,
                            data: rewardsTransactionsDataArr
                        }
                        this.setState({ rewardsTransactionsData: payLoadForTransactions })
                    })
                }
            } else {
                console.log("user not registered in lms");
                this.setState({ isAlreadyRegisteredForRewards: false })
            }
        })
    }

    redeemRewardsBtnClicked() {
        var headers = {};
        headers["CustomerType"] = this.props.userDetails.customerType;
        headers["CustomerCategory"] = this.props.userDetails.customerCategory;
        headers["CustomerSubCategory"] = this.props.userDetails.customerSubCategory;
        headers["isRedeemable"] = "true";  // 0 / 1
        headers["CONNECTIONTYPE"] = this.state.connectionType;
        headers["TransportType"] = this.state.transportType;

        if (this.props.configurationValues) {
            headers["SalesChannel"] = this.props.configurationValues.salesChannelForRedeemableAddons;
            headers["isRedeemablePoints"] = this.props.configurationValues.isRedeemablePointsForRedeemableAddons;
            headers["addonTypeForRedeemableAddons"] = this.props.configurationValues.addonTypeForRedeemableAddons;
        }

        var dataToSendForEligibilityOffer = {
            "baseOfferId": this.state.basePlanDetailsObj.planId,
            "header": headers
        }
        Network.executeAxios("fetchAddons", "POST", { "pog": this.props.cache.dataForMyAccountRedirection.serviceAddress.pog, "header": headers }, (addonResponse) => {
            Network.executeAxios("fetchEligibilityOffers", "POST", dataToSendForEligibilityOffer, (response) => {
                var finalAllAddonDetails = [];
                if (response && response[0]) {
                    finalAllAddonDetails = response;
                }
                else {
                    finalAllAddonDetails = []
                }
                this.initializeAlladdonDetails(finalAllAddonDetails, addonResponse)
            });
        })
    }

    initializeAlladdonDetails(receivedResponse, stdAddonResponse) {
        var stdAddonArr = []
        for (var p = 0; p < stdAddonResponse.length; p++) {
            if (stdAddonResponse[p].success) {
                for (var q = 0; q < stdAddonResponse[p].success.length; q++) {
                    stdAddonArr.push(stdAddonResponse[p].success[q]);
                }
            }
        }

        var eligibilityOffers = [];
        try {
            if (Array.isArray(receivedResponse)) {
                for (var x = 0; x < receivedResponse.length; x++) {
                    eligibilityOffers.push(receivedResponse[x].eligibilityOffers)
                }
            }
        } catch (err) {
            eligibilityOffers = [];
        }

        var finaleligibilityOffers = eligibilityOffers.reduce((r, e) => (r.push(...e), r), []);

        var finalProductOfferingsArray = [];
        for (var i = 0; i < finaleligibilityOffers.length; i++) {
            var productOfferingsArray = [];
            try {
                if (finaleligibilityOffers[i].productOfferings) {
                    if (finaleligibilityOffers[i].maxQuantity) {
                        var productOfferingsArrayNew = finaleligibilityOffers[i].productOfferings;
                        if (productOfferingsArrayNew.length > 0) {
                            for (var j = 0; j < productOfferingsArrayNew.length; j++) {
                                productOfferingsArrayNew[j].eligibilityType = finaleligibilityOffers[i].eligibilityType.id;
                            }
                        } else {
                            console.log("productOfferingsArrayNew length 0")
                        }
                    }
                    if (finaleligibilityOffers[i].productOfferings) {
                        productOfferingsArray.push(finaleligibilityOffers[i].productOfferings);
                        var productOfferingsArrayUpdated = productOfferingsArray.reduce((r, e) => (r.push(...e), r), []);
                        var maxQuantity = "100000000000000"
                        if (finaleligibilityOffers[i].maxQuantity) {
                            maxQuantity = finaleligibilityOffers[i].maxQuantity
                        }

                        let temp = {
                            "groupMaxQuantity": maxQuantity,
                            "groupMinQuantity": finaleligibilityOffers[i].minQuantity,
                            "productOfferings": productOfferingsArrayUpdated
                        }
                        finalProductOfferingsArray.push(temp)
                    }
                }
            }
            catch (err) { }
        }

        if (stdAddonArr.length > 0) {
            let tempObj = {
                "groupMaxQuantity": "1000000000000000",
                "groupMinQuantity": "0",
                "productOfferings": stdAddonArr
            }
            finalProductOfferingsArray.push(tempObj)
        }

        console.log("finalProductOfferingsArray", finalProductOfferingsArray)
        this.state.allAddonDetails = finalProductOfferingsArray;
        document.body.classList.add('modal-open');
        this.setState({ redeemRewardsModalVisible: true })
    }

    populateAllRedeemablePlansInSlder() {
        var isAddonPresent = false;
        const allAddonDetails = this.state.allAddonDetails.map((itemArray, keyCheck) => {
            var currentItemArray = itemArray.productOfferings;
            return currentItemArray.map((item, key) => {
                try {
                    var productPrice = {}
                    if (item.productOfferingPrice[0]) {
                        for (var i = 0; i < item.productOfferingPrice.length; i++) {
                            if (item.productOfferingPrice[i] && item.productOfferingPrice[i].priceCategory) {
                                if (item.productOfferingPrice[i].priceCategory.id === "0") {
                                    productPrice = item.productOfferingPrice[i];
                                }
                            }

                        }
                    }

                    var rewardPoint = ""
                    if (productPrice.price) {
                        rewardPoint = parseFloat(productPrice.price) * parseInt(this.state.redemptionPoint)
                    }

                    var packageAmount = ""
                    var packageAmount_sup = ""
                    try {
                        if (productPrice.price) {
                            var price = productPrice.price;
                        }
                        price = price.split(".");
                        packageAmount = price[0]
                        if (price.length > 1) {
                            packageAmount_sup = price[1];
                        } else {
                            packageAmount_sup = "00"
                        }
                    } catch (err) {
                        packageAmount = 0
                        packageAmount_sup = "00"
                    }

                    var contextValue = ""
                    try {
                        if (item.productOfferingPrice[0].rules[0].conditions[0]) {
                            for (var y = 0; y < item.productOfferingPrice[0].rules[0].conditions.length; y++) {
                                if (item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].name === "VideoFormat") {
                                    contextValue = item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].value
                                }
                            }

                        }
                    } catch (err) {
                        contextValue = ""
                    }

                    var productSubtype = {}
                    try {
                        if (item.productSpecifications[0]) {
                            productSubtype = item.productSpecifications[0].subType;
                        }
                    } catch (err) {
                        productSubtype = {}
                    }
                    var poType = {}
                    try {
                        if (item.productSpecifications[0]) {
                            poType = item.productSpecifications[0].type;
                        }
                    } catch (err) {
                        poType = {}
                    }

                    var productSpecifications = {}
                    try {
                        if (item.productSpecifications[0]) {
                            productSpecifications = item.productSpecifications[0];
                        }
                    } catch (err) {
                        productSpecifications = {}
                    }



                    var productOfferGroup = {}
                    try {
                        if (item.productOfferGroup) {
                            productOfferGroup = item.productOfferGroup;
                        }
                    } catch (err) {
                        productOfferGroup = {}
                    }

                    var connectionType = "POSTPAID"
                    if (this.props.cache.currentPlanDetails.connectionType === this.props.locales.connectionTypeForPrepaid) { connectionType = "PREPAID" }

                    var skipSom = "false";
                    var cfss = []
                    try {
                       for(var m = 0; m < item.productSpecifications.length; m++){
                           var currentPS = item.productSpecifications[m];
                           for(var n = 0; n< currentPS.cfss.length; n++){
                                var currentObjCfss = currentPS.cfss[n];
                                if(currentPS.releationships.length > 0){
                                    for(var o = 0; o < currentPS.releationships.length; o++){
                                        var relationObj =  currentPS.releationships[0];
                                        if(relationObj && relationObj.targetObject && currentObjCfss.id === relationObj.targetObject.id){
                                            if(relationObj && relationObj.skipSOM && relationObj.skipSOM == "true"){
                                                skipSom = "true";
                                            }
                                        }
                                    }
                                }
                                currentObjCfss["skip_som"] = skipSom
                                cfss.push(currentObjCfss)
                                delete currentObjCfss.validFor
                           }
                       }
                    } catch (err) {
                        cfss = []
                    }

                    var cfssArray = []
                    for (var x = 0; x < cfss.length; x++) {
                        let temp = {
                            "id": cfss[x].id,
                            "name": cfss[x].name,
                            "href": cfss[x].href,
                            "service_type": cfss[x].serviceType,
                            "service_class": cfss[x].serviceClass,
                            "transport_type": cfss[x].transportType,
                            "service_category": cfss[x].serviceCategory,
                            "characteristics": cfss[x].characteristics,
                            "skip_som": cfss[x].skip_som
                        }
                        cfssArray.push(temp);
                    }

                    var isRedeemable = false;
                    for (var y = 0; y < cfssArray.length; y++) {
                        if (cfssArray[y].characteristics) {
                            var characteristics = cfssArray[y].characteristics;
                            for (var k = 0; k < characteristics.length; k++) {
                                if (characteristics[k].name && characteristics[k].value) {
                                    if (characteristics[k].name == "isRedeemable" && characteristics[k].value == "true") {
                                        isRedeemable = true;
                                    }
                                }
                            }
                        }
                    }

                    var MinLoyaltyPoints = "0";
                    for (var y = 0; y < cfssArray.length; y++) {
                        if (cfssArray[y].characteristics) {
                            var characteristics = cfssArray[y].characteristics;
                            for (var k = 0; k < characteristics.length; k++) {
                                if (characteristics[k].name && characteristics[k].value) {
                                    if (characteristics[k].name == "MinLoyaltyPoints") {
                                        MinLoyaltyPoints = characteristics[k].value
                                    }
                                }
                            }
                        }
                    }

                    //adding CFSS char value
                    var cfssEndDateInYears = "2";
                    if(this.props.configurationValues){
                        cfssEndDateInYears = this.props.configurationValues.cfssEndDateInYears
                    }

                    for (var y = 0; y < cfssArray.length; y++) {
                        if (cfssArray[y].characteristics) {
                            var characteristics = cfssArray[y].characteristics;
                            for (var k = 0; k < characteristics.length; k++) {
                                if (characteristics[k].name) {
                                    if(characteristics[k].name === "START_DATE"){
                                        characteristics[k]["value"] =  moment().format("DD-MM-YYYY HH:mm:ss")
                                    }
                                    if(characteristics[k].name === "END_DATE"){
                                        characteristics[k]["value"] = moment().add(cfssEndDateInYears, 'years').format("DD-MM-YYYY HH:mm:ss")
                                    }
                                    if(characteristics[k].name === "NAME"){
                                        characteristics[k]["value"] = item.id
                                    }
                                }
                            }
                        }
                    }

                    var subscriptionCharges = []
                    var effective_date = moment().format("MM/DD/YYYY HH:mm:ss")
                    var expiry_date = moment().add(103, 'years').format("MM/DD/YYYY HH:mm:ss")
                    if (item.ratingParameters && item.ratingParameters[0]) {
                        var ratingParam = item.ratingParameters[0]
                        if (item.productOfferingPrice[0].priceMode.id == "1") {
                            if (ratingParam && ratingParam.subscriptionPeriod) {
                                var subscriptionPeriod = parseInt(ratingParam.subscriptionPeriod)
                                if (ratingParam.subscriptionPeriodType.id == "0") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'days');
                                } else if (ratingParam.subscriptionPeriodType.id === "1") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'weeks');
                                } else if (ratingParam.subscriptionPeriodType.id === "2") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'Monthly');
                                } else if (ratingParam.subscriptionPeriodType.id === "3") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'years');
                                } else if (ratingParam.subscriptionPeriodType.id === "4") {
                                    expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'hours');
                                }
                            }
                        }
                    }

                    expiry_date = moment(expiry_date).format("MM/DD/YYYY HH:mm:ss")
                    for (var k = 0; k < item.productOfferingPrice.length; k++) {
                        var prorata_flags = ""
                        try {
                            var prorataEnabledInSuspension = item.productOfferingPrice[k].prorataEnabledInSuspension ? "1" : "0";
                            var prorataEnabledInTermination = item.productOfferingPrice[k].prorataEnabledInTermination ? "1" : "0";
                            var prorataEnabledInPlanChange = item.productOfferingPrice[k].prorataEnabledInPlanChange ? "1" : "0";
                            var prorataEnabledInActivation = item.productOfferingPrice[k].prorataEnabledInActivation ? "1" : "0";
                            prorata_flags = prorataEnabledInActivation + prorataEnabledInTermination + prorataEnabledInSuspension + prorataEnabledInPlanChange
                        } catch (err) {
                            prorata_flags = ""
                        }
                        var factor = ""
                        if (item.productOfferingPrice[k].factor) {
                            factor = item.productOfferingPrice[k].factor
                        }
                        var frequency = ""
                        if (item.productOfferingPrice[k].frequency) {
                            frequency = item.productOfferingPrice[k].frequency.id
                        }

                        let tempCharges = {}
                        try {
                            tempCharges = {
                                "upc_charge_id": item.productOfferingPrice[k].id,
                                "charge_type": item.productOfferingPrice[k].priceMode.id,
                                "charge_name": item.productOfferingPrice[k].name,
                                "charge_desc": item.productOfferingPrice[k].description,
                                "start_date": moment().format("MM/DD/YYYY HH:mm:ss"),
                                "end_date": expiry_date,
                                "charge_tax": item.productOfferingPrice[k].priceCode.taxCategoryId,
                                "charge_validity": "",
                                "charge_category": item.productOfferingPrice[k].priceCategory.billingChargeType.id,
                                "charge_id": item.id,
                                "discount_type": item.productOfferingPrice[k].priceType.name,
                                "epc_enabled": "1",
                                "quantity_based": "",
                                "charge_classification": "",
                                "charge_amount_type": item.productOfferingPrice[k].priceType.name,
                                "charge_frequency": frequency,
                                "charge_factor": factor,
                                "is_prorata": item.productOfferingPrice[k].prorataEnable ? "1" : "0",
                                "prorata_flags": prorata_flags,
                                "charge_code": item.productOfferingPrice[k].priceCode.id
                            }
                            if (connectionType === "POSTPAID") {
                                tempCharges["charge_amount"] = item.productOfferingPrice[k].price
                                tempCharges["total_charge"] = item.productOfferingPrice[k].price
                            } else {
                                tempCharges["charge_amount"] = "0"
                                tempCharges["total_charge"] = "0"
                            }
                        } catch (err) {
                            tempCharges = {}
                        }
                        subscriptionCharges.push(tempCharges)
                    }

                    var pogIdFromResponse = item.productOfferGroup.id;
                    var productFamilyIdFromResponse = item.productOfferGroup.productFamily.id

                    var currentAddonDataTemp = {};
                    currentAddonDataTemp["id"] = item["id"];
                    currentAddonDataTemp["name"] = item["marketingDescription"];
                    currentAddonDataTemp["description"] = item["description"] || "NA";
                    currentAddonDataTemp["offerAmount"] = productPrice.price || 0;
                    currentAddonDataTemp["effective_date"] = effective_date;
                    currentAddonDataTemp["expiry_date"] = expiry_date;
                    currentAddonDataTemp["productId"] = productOfferGroup.id;
                    currentAddonDataTemp["productName"] = productOfferGroup.name;
                    currentAddonDataTemp["poType"] = poType.id;
                    currentAddonDataTemp["subscriptionCharges"] = subscriptionCharges;
                    currentAddonDataTemp["contextValue"] = contextValue;
                    currentAddonDataTemp["pogIdFromResponse"] = pogIdFromResponse;
                    currentAddonDataTemp["eligibilityType"] = item.eligibilityType || 0;
                    currentAddonDataTemp["productFamilyIdFromResponse"] = productFamilyIdFromResponse;
                    currentAddonDataTemp["isRedeemable"] = isRedeemable;
                    currentAddonDataTemp["MinLoyaltyPoints"] = MinLoyaltyPoints;
                    currentAddonDataTemp["connectionType"] = connectionType;
                    if (cfssArray.length > 0) {
                        currentAddonDataTemp["cfss"] = cfssArray;
                    }
                    if(productSpecifications && productSpecifications.subType && productSpecifications.subType.id)
                    currentAddonDataTemp["po_sub_type"] = productSpecifications.subType.id || 0;
        
                    if(productSubtype && productSubtype.id)
                    currentAddonDataTemp["productSubtype"] = productSubtype.id || 0;
        
                }
                catch (err) {
                    currentAddonDataTemp = {}
                }
                var currentAddonData = encodeURIComponent(JSON.stringify(currentAddonDataTemp));

                var isFnfAddonPresent = "false"
                if (item.ratingParameters && item.ratingParameters[0]) {
                    isFnfAddonPresent = item.ratingParameters[0].friendsAndFamily;
                }

                var maxQuantity = "1"
                if (item.maxQuantity) {
                    maxQuantity = item.maxQuantity
                }

                var minQuantity = "0"
                if (item && item.minQuantity) {
                    minQuantity = item.minQuantity
                }
               
                if(parseInt(this.state.rewardPointsFromLMS) >= parseInt(MinLoyaltyPoints) && isFnfAddonPresent !== "true") {
                    isAddonPresent = true;
                    return (
                        <div className="col-md-6 mb-5" key={key}>
                            <div className="rewards-data-box py-3">
                                <div className="col-md-12 plan-heading">{item.marketingDescription}</div>
                                <div className="col-md-12 plan-desc">{item.description}</div>
                                <div className="reward-points-div d-flex justify-content-center align-items-center flex-column"><div><div className="text-center" style={{ fontWeight: 500 }}>{MinLoyaltyPoints}</div><div className="text-center" style={{ fontSize: 12 }}>points</div></div></div>
                                <div className="col-md-12 d-flex justify-content-end">
                                    <div className="redeem-btn col-md-3 d-flex align-items-center justify-content-center" onClick={() => { this.rewardsRedeemBtnClicked(MinLoyaltyPoints,currentAddonData) }} >Redeem</div>
                                </div>
                            </div>
                        </div>
                    );
                }
            });
        })

        if (isAddonPresent) {
            return (<div className="allAddonDetailContainer row col-md-12 p-0 mx-auto">{allAddonDetails}</div>);
        } else {
            return (<div className="allAddonDetailContainer row m-0 col-md-12 p-0 mx-auto"><div className="col-md-12 mx-auto mt-3 row p-0"><NoDataFound content="No add-ons are available" /></div></div>);
        }
    }

    fetchTransactionHistory() {
        var dataToSend = {
            "serviceType": this.state.serviceType,
            "serviceId": this.props.currentServiceDetails.currentServiceId,
            "fromDate": moment(this.state.transactionHistoryDateFrom).format("YYYYMMDD"),
            "toDate": moment(this.state.transactionHistoryDateTo).format('YYYYMMDD'),
            "limit": "10",
            "offset": this.state.offsetForTransactionHistory.toString()
        }
        this.setState({ isLoading: true })
        Network.executeAxios("transactionHistory", "POST", dataToSend, (transactionHistoryResponse) => {
            var valuesArr = []
            var totalRecords = "0"
            try {
                if (transactionHistoryResponse && transactionHistoryResponse["RSP-REPORT"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"]["Values"]) {
                    var values = transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"]["Values"]
                    if (Array.isArray(values)) {
                        valuesArr= values;
                    } else {
                        valuesArr.push(values)
                    }
                }
                if (transactionHistoryResponse && transactionHistoryResponse["RSP-REPORT"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-PARAM"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-PARAM"]["ROWCOUNT"]) {
                    var data = transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-PARAM"]["ROWCOUNT"]
                    totalRecords = data["_text"]
                }
            } catch (err) {

            }
            this.setState({totalTransactionDetailsCount: parseInt(totalRecords)})
            this.initializeTransactionHistory(valuesArr)
        })
    }

    populateTransactionHistoryDetailsInSlider(){
        const transactionDetails = this.state.transactionHistorySliderArr.map((item, key) => {
            return(
                <tr key={key}>
                    <td style={{ color: '#231F20', fontSize: 12, fontWeight: 400 }}>{item.key}</td>
                    <td style={{ color: '#231F20', fontSize: 14, fontWeight: 600 }}>{item.value}</td>
                </tr>
            )
        })
        if (this.state.transactionHistorySliderArr.length> 0) return( <tbody >{transactionDetails}</tbody>)
        else return (<NoDataFound content="No Details Found"/>);
    }


    initializeTransactionHistory(receivedResponse) {
        var headerArray = [];
        var tempHead = "Service,Date and time,Charge,Duration,Balance,MSISDN,B party,Location,Status";
        headerArray = tempHead.split(",");
        var finalArrayForTransactionHistory = [];
        try {
            if (receivedResponse.length > 0) {
                for (var k = 0; k < receivedResponse.length; k++) {
                    var row = receivedResponse[k]._text;

                    //normal
                    var responseArray = row.split(",");
                    var obj = {};
                    for (var i = 0; i < headerArray.length; i++) {
                        if(headerArray[i]=="Date and time"){
                            obj[headerArray[i]] = GeneralUtils.formatDateToStandardForm(responseArray[i],"DD-MM-YYYY hh:mm:ss","MM/DD/YYYY hh:mm:ss")
                        }
                        else {
                            obj[headerArray[i]] = responseArray[i];
                        }
                    }
                   
                    //slider
                        var responseArraySlider = row.split(",MSISDN=")[1];
                        responseArraySlider=responseArraySlider.split(",")
                        var tempObj={}
                        var sliderFinalArr = []
                        for(var m=0; m< responseArraySlider.length;m++){
                            var currentObj = responseArraySlider[m].split("=")
                            if(m==0){
                                tempObj = {
                                    "key": "MSISDN",
                                    "value": currentObj[0]
                                }
                            } else {
                                if(currentObj[0]=="ActivationDate"){
                                    currentObj[1] = GeneralUtils.formatDateToStandardForm(currentObj[1],"YYYY-MM-DD","MM/DD/YYYY")
                                } 
                                if(currentObj[0]=="Call Start Time"){
                                    currentObj[1] = GeneralUtils.formatDateToStandardForm(currentObj[1],"DD-MM-YYYY hh:mm:ss","MM/DD/YYYY hh:mm:ss")
                                } 
                                tempObj = {
                                    "key": currentObj[0],
                                    "value": currentObj[1]
                                }
                                
                            }
                            sliderFinalArr.push(tempObj)
                        }
                       
                        obj["details"] = sliderFinalArr;

                        finalArrayForTransactionHistory.push(obj)
                }
            }
        }
        catch (err) {
            finalArrayForTransactionHistory = [];
        }
        this.state.transactionHistoryData = finalArrayForTransactionHistory;
        // this.setState({dummy:"dummy"})
        console.log("transactionHistoryData >>", this.state.transactionHistoryData);
        this.setState({
            transactionHistoryPayload: {
                totalRecords: this.state.totalTransactionDetailsCount,
                data: this.state.transactionHistoryData
            },
            isLoading: false
        });
        if (this.state.isFirstTimeLoading == false)
            document.getElementById('transactionHistoryForGsmPart').scrollIntoView();
        this.setState({ isFirstTimeLoading: false })
    }

    transactionHistoryTableHandler = (dataObject) => {
        if (dataObject.type === "pagination") {
            var dataToSend = {
                "serviceType": this.state.serviceType,
                "serviceId": this.props.currentServiceDetails.currentServiceId,
                "fromDate": moment(this.state.transactionHistoryDateFrom).format("YYYYMMDD"),
                "toDate": moment(this.state.transactionHistoryDateTo).format('YYYYMMDD'),
                "limit": "10",
                "offset": dataObject.offset
            }

            Network.executeAxios("transactionHistory", "POST", dataToSend, (transactionHistoryResponse) => {
                // document.getElementById('transactionHistoryForGsmPart').scrollIntoView();
                var valuesArr = []
                try {
                    if (transactionHistoryResponse && transactionHistoryResponse["RSP-REPORT"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"] && transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"]["Values"]) {
                        var values = transactionHistoryResponse["RSP-REPORT"]["PARAMETERS"]["REPORT-DETAILS"]["Values"]
                        if (Array.isArray(values)) {
                            valuesArr= values;
                        } else {
                            valuesArr.push(values)
                        }
                    }
                } catch (err) {
    
                }

                this.initializeTransactionHistory(valuesArr)
            })
        }  else if (dataObject.type === "viewMore") {
            var transactionHistorySliderArr = [];
            if(dataObject.data && dataObject.data.details && dataObject.data.details[0])
            console.log("dataObject.data.details",dataObject.data.details)
            console.log("dataObject.data",dataObject.data)
            transactionHistorySliderArr = dataObject.data.details;
            this.setState({
                transactionHistorySliderArr: transactionHistorySliderArr,
                isTransactionHistoryModalVisible: true,
                isLoading: false
            })
        }

    }

    transactionHistoryModalHandler = (dataObject) => {
        if (dataObject.type  === "cancel") {
            this.setState({ isTransactionHistoryModalVisible: false })
        }
    }

    rewardsTransactionsTableHandler = (dataObject) => {
        console.log("dataObject >>", dataObject);
        if (dataObject.type === "firstTimeLoad" || dataObject.type === "pagination") {
            this.setState({ "dummy": "dummy" });
        }
    }

    initialiseRewardPoints() {
        Network.executeAxios("getLoyaltyPoints", "POST", { "serviceId": this.state.userDetails.service_id }, (loyaltyPointsResponse) => {
            if (loyaltyPointsResponse && loyaltyPointsResponse.loyaltyDetails && loyaltyPointsResponse.loyaltyDetails.rewardPoints) {
                var rewardPoints = GeneralUtils.formatNumberToStandardForm(loyaltyPointsResponse.loyaltyDetails.rewardPoints)
                rewardPoints = rewardPoints.split(".");
                var rewardPointsFormatted = rewardPoints[0]
                this.setState({ rewardPointsFromLMS: rewardPointsFormatted })
            }
            this.props.setCache("rewardPointsFromLMS", rewardPointsFormatted)
            if (this.state.isPopupVisible) {
                setTimeout(() => {
                    this.setState({ isPopupVisible: false });
                }, 8000);
            }
        })
    }

    initializeActivationDate(receivedSubscriberResponse) {
        try {
            var receivedResponse = receivedSubscriberResponse.service_info;
            var params = receivedResponse.basic_details;
            var finalActivationDate = "";
            for (var i = 0; i < params.length; i++) {
                if (params[i].id === "activation_date") {
                    finalActivationDate = params[i].value;
                }
            }
            this.setState({
                activationDate: GeneralUtils.formatDateToStandardForm(finalActivationDate, this.props.configurationValues.dateFormatForBilling)
            })
        } catch (Exception) {

        }
    }

    initialiseSubscriberInfo(){
        this.setState({isLoading: true})
        Network.executeAxios("fetchSubscriberInfo", "POST", {"serviceId": this.state.userDetails.service_id} , (fetchSubscriberInfoResponse) => {
            this.props.setCache("subscriberInfo", fetchSubscriberInfoResponse);
            var finalDNDStatus = "";
            var maBalance = 0;
            var maBalance_sup = "00";
            var lastRechargeDate = "";
            var accountId = "";
            var payGoStatus = true;
         
            try {
                var params = fetchSubscriberInfoResponse.service_info.basic_details;
                for(var i=0; i<params.length; i++){
                    if (params[i].id === "dndStatus") {
                        finalDNDStatus = params[i].value;
                    }
                    if (params[i].id === "payGoFlag") {
                        payGoStatus = params[i].value;
                    }

                    if (params[i].id === "service_code") {
                        this.state.serviceCode = params[i].value
                    }
                   
                    if (params[i].id === "maBalance") {
                        maBalance = params[i].value
                    }  
                    if (params[i].id === "lastRechargeTime") {
                        lastRechargeDate = params[i].value
                    } 
                    if (params[i].id === "rate_plan_id") {
                        this.state.planId = params[i].value;
                    }
                    if (params[i].id === "fnfAllowed") {
                        this.setState({isFnFAdded: params[i].value})
                    }
                    if (params[i].id === "ocs_status") {
                        this.setState({currentPrepaidStatus: params[i].value})
                    }
                    if (params[i].id === "account_id") {
                        this.setState({accountId: params[i].value})
                    }
                    if (params[i].id === "access_type") {
                        this.setState({transportType: params[i].value})
                    }
                }
                if (finalDNDStatus === "1") {
                    finalDNDStatus = true;
                } else {
                    finalDNDStatus = false;
                }

                if(payGoStatus === "true") payGoStatus = true;
                else payGoStatus = false

                this.state.dndStatus = finalDNDStatus;
                this.state.payGoStatus = payGoStatus;

                if(this.state.isPopupVisible){
                    setTimeout(() => {
                        this.setState({ isPopupVisible: false });
                    }, 8000);
                }
            } catch(err){
                console.log("errrrr>>>>",err)
            }
           
            var Price = GeneralUtils.formatNumberToStandardFormWithoutComma(maBalance)
            Price = Price.split(".");
            maBalance = Price[0]
            if (Price.length > 1) {
                maBalance_sup = Price[1];
            } else {
                maBalance_sup = "00"
            }

            if(lastRechargeDate !== ""){
                lastRechargeDate = GeneralUtils.formatDateToStandardForm(lastRechargeDate, this.props.configurationValues.dateFormatForBilling)
            }
            this.setState({maBalance: maBalance, maBalance_sup: maBalance_sup, lastRechargeDate: lastRechargeDate})
            if(this.state.isQueryPlanCallRequired){
                var basePlanArr = [];
                Network.executeAxios("queryPlan", "POST", {"serviceId":this.props.currentServiceDetails.currentServiceId,"serviceCode":this.state.serviceCode, "type": "GSM"} , (queryPlanResponse) => {
                    
                    var isDeviceAvailable = false;
                    if(queryPlanResponse && queryPlanResponse.subscriptions && queryPlanResponse.subscriptions[0]){
                        var allSubscriptions = queryPlanResponse.subscriptions;
                        for(var q=0; q<allSubscriptions.length; q++){
                            if(allSubscriptions[q].is_base_plan === "1")
                                basePlanArr.push(allSubscriptions[q])
                            if(allSubscriptions[q].is_base_plan === "0" && allSubscriptions[q].subscription_type === "1")
                                isDeviceAvailable = true;
                        }
                    }
                    if(isDeviceAvailable){
                        Network.executeAxios("fetchResourceDetails", "POST", {"serviceId":this.props.currentServiceDetails.currentServiceId} , (resourceResponse) => {
                            this.getAllDevices(allSubscriptions, resourceResponse);
                        })
                    } else {
                        this.getAllDevices(allSubscriptions, []);
                    }
                    this.populateBasePlanDetails(basePlanArr);
                    this.getAllAddons(queryPlanResponse);
                    this.fetchTransactionHistory();
                    this.setState({isQueryPlanCallRequired: false });
                    if(this.props.cache.isAddFnFAddon === "addFnFAddon")
                        this.setState({isFriendsAndFamilySectionVisible: true})
            })
            } else {
                if(this.props.cache.isAddFnFAddon === "addFnFAddon"){
                    this.setState({isFriendsAndFamilySectionVisible: true})
                }
                this.setState({isLoading: false})
            }
        })
    }

    handleInputValueChangeToggle(name, event, type) {
        const valueChecked = event.target.checked;
        if (type === "checkbox" && name === "dndStatus") {
            var action = "0"
            if(valueChecked){
                action = "1"
            }
            var dataToSend = {
                "msisdn" : this.state.userDetails.service_id,
                "action": action
            }
            if(valueChecked){
                Swal.fire({
                    title: this.props.locales.enableDndConfirmationMsgTitleInSwal,
                    text: this.props.locales.dndIncomingCallBlockMsgTextInSwal,
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) { 
                        this.setState({popupContent: this.props.locales.dndEnabledPopupContent})
                        this.callUpdateDnd(dataToSend);
                    } 
                });
            } else {
                this.setState({popupContent: this.props.locales.dndDisabledPopupContent})
                this.callUpdateDnd(dataToSend);
            }
        } else if(type === "checkbox" && name === "payGoStatus"){
            var payGoToSend = "false"
            if(valueChecked){
                payGoToSend = "true"
            }
            var dataToSend = {
                "serviceId" : this.state.userDetails.service_id,
                "payGoToSend": payGoToSend
            }
         
            if(valueChecked === false){
                Swal.fire({
                    title: this.props.locales.enablePayGoConfirmationMsgTitleInSwal,
                    text: this.props.locales.payGoSubTextInConfirmationSwal,
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) { 
                        this.setState({popupContent: this.props.locales.payGoDisabledPopupContent})
                        this.callUpdatePayGo(dataToSend);
                    } 
                });
            } else {
                this.setState({popupContent: this.props.locales.payGoEnabledPopupContent})
                this.callUpdatePayGo(dataToSend);
            }
        }
    }

    callUpdatePayGo(dataToSend){
        this.setState({isLoading: true})
        Network.executeAxios("updatePayGo", "POST", dataToSend, (updatePayGoResponse) => {
            this.setState({isLoading: false})
            if(updatePayGoResponse && updatePayGoResponse.resultCode){
                if(updatePayGoResponse.resultCode === "0"){
                    this.setState({isPopupVisible: true})
                    this.initialiseSubscriberInfo()
                } else {
                    Swal.fire(this.props.locales.internalErrorTitleInSwal,"","")
                }
            } else {
                Swal.fire(this.props.locales.internalErrorTitleInSwal,"","")
            }
        })
    }



    getAllDevices(response, resourceDetails) {
        var subscriptionsArray = []
        var devicesArray = []
        try {
                subscriptionsArray = response;
                console.log("subscriptionsArray",subscriptionsArray)
                if (subscriptionsArray.length > 0) {
                    for (var i = 0; i < subscriptionsArray.length; i++) {
                        if (subscriptionsArray[i].is_base_plan === "0" && subscriptionsArray[i].subscription_type === "1") {    // for devices type = 1   as of now taking as 0
                           console.log("subscriptionsArray",subscriptionsArray[i])
                            devicesArray.push(subscriptionsArray[i])
                            //devicesArray["isIncluded"] = false
                        }
                    }
                }
        } catch (e) {
            subscriptionsArray = []
            devicesArray = []
        }

        for (var k = 0; k < devicesArray.length; k++) {
            devicesArray[k]["serviceName"] = this.state.userDetails.service_name
            var currentArray = devicesArray[k]
            if (currentArray.linked_plan_id === "") {
                currentArray["isIncluded"] = false
            }
            else {
                currentArray["isIncluded"] = true
                var chargeAmount = 0
                try {
                    chargeAmount = this.state.allDevicesArray.charges[0].charge_amount
                } catch (err) {
                    chargeAmount = 0
                }
                this.state.allServicesCharge = this.state.allServicesCharge + parseFloat(chargeAmount)
            }
        }
       
        var finalDeviceArray = [];
        var resourceArr = [];
        if(resourceDetails && resourceDetails.BillingSystem && resourceDetails.BillingSystem.response 
            && resourceDetails.BillingSystem.response.dataset && resourceDetails.BillingSystem.response.dataset.resource_details
            && resourceDetails.BillingSystem.response.dataset.resource_details[0] )
            resourceArr = resourceDetails.BillingSystem.response.dataset.resource_details
            for(var k=0; k< resourceArr.length; k++){

            }

        for (var x = 0; x< devicesArray.length; x++) {
            var currentObj = devicesArray[x]
            for (var y = 0; y<resourceArr.length; y++) {
                var currentResourceObj = resourceArr[y];
                const serviceDetailsFound = currentResourceObj.service_details.some(el => el.service_id === this.props.currentServiceDetails.currentServiceId);
                if (serviceDetailsFound && (currentObj.subscription_id === currentResourceObj.subscription_id)) {
                    currentObj["macAddress"] = resourceArr[y].mac_id;
                    currentObj["resource_serial_number"] = resourceArr[y].resource_serial_number;
                    finalDeviceArray.push(currentObj)
                }
            }
        }
        console.log("devicesArray>>>",finalDeviceArray)
        this.state.devicesArray = finalDeviceArray;
        this.setState({ "dummy": "dummy" })
    }

    getUrlParameter(param) {
        var found;
        window.location.pathname.substr(1).split("&").forEach(function (item) {
            if (param == item.split("=")[0]) {
                found = item.split("=")[1];
            }
        });
        //found=found.slice(3, 13);                  //only for scrum testing
        return found;
    };

    handleContactNumberOnBlur = (name) => {
        var formatedData = GeneralUtils.formatPhoneNumberToUsFormatNew(this.state[name]);
        this.state[name] = formatedData;
        this.setState({ dummy: "dummy" });
    }

    initRange = (receivedVal) => {
        this.state.rangeVal = receivedVal
        const slider = document.getElementById("rangeSliderForRewardPoints")
        const min = slider.min
        const max = slider.max
        const value = receivedVal

        slider.style.background = `linear-gradient(to right, #0049A5 0%, #0049A5 ${(value - min) / (max - min) * 100}%, #DEE2E6 ${(value - min) / (max - min) * 100}%, #DEE2E6 100%)`

        slider.oninput = function () {
            this.style.background = `linear-gradient(to right, #0049A5 0%, #0049A5 ${(this.value - this.min) / (this.max - this.min) * 100}%, #DEE2E6 ${(this.value - this.min) / (this.max - this.min) * 100}%, #DEE2E6 100%)`
        }
        this.setState({ "dummy": "dummy" })
    }

    populateBasePlanDetails(response) {
        var planName = "";
        var planDesc = "";
        var packageAmount = "0";
        var packageAmount_sup = "00";
        var productId = "";
        var planId = "";
        var expiryDate = "NA";
        var activationDate = "NA"
        var isRecurring= true;
        var benefits = [];
        var subscriptionId = "";
        try {
            planName = response[0].plan_name;
            planDesc = response[0].plan_desc;
            productId = response[0].product_id;
            planId = response[0].plan_id;
            subscriptionId = response[0].subscription_id;
            if(response[0] && response[0].expiry_date && response[0].expiry_date !== "")
                expiryDate = GeneralUtils.formatDateToStandardForm(response[0].expiry_date, this.props.configurationValues.dateFormatForBilling)
            if(response[0] && response[0].activation_date && response[0].activation_date !== "")
                activationDate = GeneralUtils.formatDateToStandardForm(response[0].activation_date, this.props.configurationValues.dateFormatForBilling)
            var packageAmount = 0;
            var packageAmount_sup = 0;
            var basePlanPrice = 0;
            var discountPrice = 0;
            var discountName = "Discount"
            try {
                var currentSubscription = response[0].subscription_charges
                this.state.basePlanArray = currentSubscription

                for (var i = 0; i < currentSubscription.length; i++) {
                    var currentChargeData = currentSubscription[i]
                    if (currentChargeData.charge_category === "2" || currentChargeData.charge_category === "1") {
                        basePlanPrice = currentChargeData.charge_amount;
                        if(currentChargeData.charge_type === "1") isRecurring =false;
                    }
                    if (currentChargeData.charge_category === "5" && currentChargeData.discount_type === "F") {
                        discountPrice = currentChargeData.discount_value
                        discountName = currentChargeData.discount_name
                    } else if (currentChargeData.charge_category === "5" && currentChargeData.discount_type === "P") {
                        discountPrice = ((parseFloat(basePlanPrice) * parseFloat(currentChargeData.discount_value)) / 100);
                        discountName = currentChargeData.discount_name
                    }
                }
            }
            catch (err) {

            }
            this.state.allServicesCharge = (parseFloat(this.state.allServicesCharge) + parseFloat(basePlanPrice)) - parseFloat(discountPrice)
            var Price = GeneralUtils.formatNumberToStandardForm(this.state.allServicesCharge)
            Price = Price.split(".");
            packageAmount = Price[0]
            if (Price.length > 1) {
                packageAmount_sup = Price[1];
            } else {
                packageAmount_sup = "00"
            }

        } catch (err) {
            planName = "";
            planDesc = "";
        }
        var subscription = {}
        try {
            subscription = response[0]
            subscription.subscription_charges = subscription.charges;
            delete subscription.charges;
        } catch {

        }

        if(response && response[0] && response[0].benefits){
            var benefitArr = response[0].benefits
            for(var y=0; y< benefitArr.length; y++){
                var benefitObj = benefitArr[y];
                if(benefitObj && benefitObj.initial_value){
                    var temp = {
                        val: benefitObj.value,
                        initialVal: benefitObj.initial_value || 0,
                        unit: benefitObj.unit_type,
                        usageName: benefitObj.name || "NA"                      
                     }
                     if(benefitObj.unit_type === "Seconds"){
                        var currentVal=benefitObj.value;
                        currentVal = parseFloat(currentVal)/60;
                        var initialVal= benefitObj.initial_value;
                        initialVal=parseFloat(initialVal)/60;
                        temp["val"] = currentVal.toFixed(2);
                        temp["initialVal"] = initialVal.toFixed(2);
                        temp["unit"] = "Minutes";
                     }
                     if(benefitObj.unit_type === "Bytes"){
                        var currentVal=benefitObj.value;
                        currentVal = parseFloat(currentVal)/1048576;
                        var initialVal= benefitObj.initial_value;
                        initialVal=parseFloat(initialVal)/1048576;
                        temp["val"] = currentVal.toFixed(2);
                        temp["initialVal"] = initialVal.toFixed(2);
                        temp["unit"] = "MB";
                     }
                     benefits.push(temp)
                }
            }
        }

        var temp = {
            activePlanName: planName,
            activePlanDesc: planDesc,
            activePlanAmount: packageAmount,
            activePlanDecimal: packageAmount_sup,
            discountAmount: GeneralUtils.formatNumberToStandardForm(discountPrice),
            discountName: discountName,
            basePlanPrice: GeneralUtils.formatNumberToStandardForm(basePlanPrice),
            allBasePlanServiceCharge: this.state.allServicesCharge,
            subscription: subscription,
            serviceId: this.state.userDetails.service_id,
            productId: productId,
            contractId: this.state.contractId,
            serviceName: this.state.userDetails.service_name,
            serviceCode: this.state.userDetails.network_type,
            planId: planId,
            isContractExpired: this.state.isContractExpired,
            connectionType: this.state.connectionType,
            isRecurring: isRecurring,
            taxArray: [],
            discountArray: [],
            subscriptionId: subscriptionId
        }
        this.props.setCache("currentPlanDetails", temp);

        var activeBasePlanDetailsObj = {
            planId: planId,
            activePlanName: planName,
            activePlanDesc: planDesc,
            activePlanAmount: packageAmount,
            activePlanDecimal:  packageAmount_sup,
            discountAmount: GeneralUtils.formatNumberToStandardForm(discountPrice),
            discountName: discountName,
            basePlanPrice: GeneralUtils.formatNumberToStandardForm(basePlanPrice),
            postpaidExpiryDate: expiryDate,
            activationDate: activationDate,
            isRecurring: isRecurring,
            benefits: benefits
        }
       
        this.setState({basePlanDetailsObj: activeBasePlanDetailsObj})
        console.log("ACTIVE PLAN DETAILS >>>",activeBasePlanDetailsObj)
        this.state.currentService = [
            {
                "currentPlanName": planName,
                "subscriptions": response.subscriptions
            }
        ]
    }

    getAllAddons(receivedResponse) {
        var receivedResponse = receivedResponse.subscriptions
        var allAddonArray = []
        var planIdForFnF = ""
        var activationDate = ""
        var addonExpiryDate = ""

        var changeBaseAddonData = {
            "linkedPlanId": "",
            "planId": "",
            "subscriptionId": ""
        }
      
        try {
            for (var i = 0; i < receivedResponse.length; i++) {
                var currentAddon = receivedResponse[i];
                var benefits = []
                if (currentAddon.is_base_plan === "0" && currentAddon.subscription_type === "0") {
                  
                    if(currentAddon.linked_plan_id === this.state.basePlanDetailsObj.planId){
                        changeBaseAddonData = {
                            "planId": currentAddon.plan_id,
                            "subscriptionId": currentAddon.subscription_id
                        }
                    }
                    changeBaseAddonData["linkedPlanId"] = this.state.basePlanDetailsObj.planId;
                    var todayDate = moment();
                    var expiryDate = moment(currentAddon.expiry_date, "MM/DD/YYYY HH:mm:ss", "MM-DD-YYYY");
                    var dDiff = expiryDate.diff(todayDate, 'seconds');

                    if (dDiff > 0) {
                        if (currentAddon && currentAddon.ocs_plan_type && currentAddon.ocs_plan_type.toUpperCase() === "FNF") {
                            planIdForFnF = currentAddon.plan_id;
                            addonExpiryDate = GeneralUtils.formatDateToStandardForm(currentAddon.expiry_date, "MM/DD/YYYY HH:mm:ss", "MM/DD/YYYY");
                            activationDate = GeneralUtils.formatDateToStandardForm(currentAddon.activation_date, "MM/DD/YYYY HH:mm:ss", "MM/DD/YYYY");
                        }

                        if (currentAddon && currentAddon.benefits) {
                            var benefitArr = currentAddon.benefits
                            for (var y = 0; y < benefitArr.length; y++) {
                                var benefitObj = benefitArr[y];
                                var temp = {
                                    val: benefitObj.value,
                                    initialVal: benefitObj.initial_value || 0,
                                    unit: benefitObj.unit_type,
                                    usageName: benefitObj.name || "NA"                      
                                 }
                                 if(benefitObj.unit_type === "Seconds"){
                                    var currentVal=benefitObj.value;
                                    currentVal = parseFloat(currentVal)/60;
                                    var initialVal= benefitObj.initial_value;
                                    initialVal=parseFloat(initialVal)/60;
                                    temp["val"] = currentVal.toFixed(2);
                                    temp["initialVal"] = initialVal.toFixed(2);
                                    temp["unit"] = "Minutes";
                                 }
                                 if(benefitObj.unit_type === "Bytes"){
                                    var currentVal=benefitObj.value;
                                    currentVal = parseFloat(currentVal)/1048576;
                                    var initialVal= benefitObj.initial_value;
                                    initialVal=parseFloat(initialVal)/1048576;
                                    temp["val"] = currentVal.toFixed(2);
                                    temp["initialVal"] = initialVal.toFixed(2);
                                    temp["unit"] = "MB";
                                 }
                                benefits.push(temp)
                            }
                        }

                        if (currentAddon.linked_plan_id === "") {
                            var isRecurring = true;
                            let temp = {
                                "addonName": currentAddon.plan_name,
                                "addonDesc": currentAddon.plan_desc,
                                "addonPrice": currentAddon.subscription_charges[0].charge_amount,
                                "planId": currentAddon.plan_id,
                                "subscription_charges": currentAddon.subscription_charges,
                                "isIncluded": false,
                                "benefits": benefits
                            }
                            if (currentAddon.subscription_charges && currentAddon.subscription_charges[0].charge_type === "1") isRecurring = false;
                            temp["isRecurring"] = isRecurring
                            allAddonArray.push(temp)
                        } else {
                            var isRecurring = true;
                            let temp = {
                                "addonName": currentAddon.plan_name,
                                "addonDesc": currentAddon.plan_desc,
                                "addonPrice": "0",
                                "planId": currentAddon.plan_id,
                                "subscription_charges": currentAddon.subscription_charges,
                                "isIncluded": true,
                                "benefits": benefits
                            }
                            if (currentAddon.subscription_charges && currentAddon.subscription_charges[0].charge_type === "1") isRecurring = false;
                            temp["isRecurring"] = isRecurring
                            allAddonArray.push(temp)
                            this.state.allServicesCharge = this.state.allServicesCharge + parseFloat(currentAddon.subscription_charges[0].charge_amount)
                        }
                    }
                }
            }
        } catch (err) {
            allAddonArray = []
        }

        this.props.setRegisterDetails("generalResponse.changeBaseAddonData", changeBaseAddonData)

        console.log("allAddon Details>>>>", allAddonArray)
        this.setState({ addonExpiryDate: addonExpiryDate, allAddonArray: allAddonArray, planIdForFnF: planIdForFnF, activationDateForFnF: activationDate })
    }

    populateAddons() {
        const allAddons =   this.state.allAddonArray
        .filter(item => {
            var addonSearchName=""; var addonName="";
            if(this.state.addonSearchName !== "") addonSearchName= this.state.addonSearchName.toUpperCase();
            if(item.addonName !== "") addonName= item.addonName.toUpperCase()
            if (!addonSearchName) return true;
            if (addonName.includes(addonSearchName)) {
                return true;
            }
            return false;
        })
        .map((item, key) => {
            var widthFromVar = 0;
            var used = 0;
           
            if(item.benefits.length > 0){
                used = parseFloat(item.benefits[0].initialVal) - parseFloat(item.benefits[0].val)
                if(typeof used === 'number' && (used % 1) === 0) {
                    // data is an integer
                } else {
                    used = GeneralUtils.formatNumberToStandardFormWithoutComma(used)
                }
                widthFromVar = ((parseFloat(used) / parseFloat(item.benefits[0].initialVal)) * 100) + "%"
            }
            var packageAmount = 0
            var packageAmount_sup = 0
            var discountPrice = GeneralUtils.formatNumberToStandardForm(item.addonPrice)
            discountPrice = discountPrice.split(".");
            packageAmount = discountPrice[0]
            if (discountPrice.length > 1) {
                packageAmount_sup = discountPrice[1];
            } else {
                packageAmount_sup = "00"
            }
           
            return (
                <div className="col-md-4 row p-0 m-0 pb-3 justify-content-center" key={key}>
                    <div className="activePlanContainer p-3" style={{ minHeight: 165, width: '93%',border: '1px solid rgba(2,133,202,0.2)' }}>
                        <div className="d-flex justify-content-between">
                            <div><img src={phoneDisabled} alt="" /></div>
                            {item.isIncluded ? <span style={{ fontSize: 12, color: '#FE9A2E' }}>{this.props.locales.includedTxtInDevicesComponent}</span>
                                :
                                parseFloat(packageAmount)> 0 ?
                                <span style={{ color: '#231F20' }} className="d-flex">
                                    <span>{Constants.dollarSign}</span><span style={{ lineHeight: '32px', fontSize: 28 }}>{packageAmount}</span><span>{packageAmount_sup}
                                    {item.isRecurring ? this.props.locales.perMonthTextForAmount : "" }
                                    </span>
                                </span>
                                : null 
                            }
                        </div>
                        <div style={{ color: '#231F20', fontWeight: 500, fontSize: 18 }}>{item.addonName}</div>
                        <div className="py-2" style={{ color: '#6d6d6d', fontSize: 14 }}>{item.addonDesc}</div>

                        {/* usageReport */}
                       {item.benefits.length > 0 ?
                        <div className="">
                                <div className="d-flex justify-content-between" style={{fontSize:12,color:'#0049A5'}}>
                                    <div>{this.props.locales.usageSecHeadingInAllAddons}</div>
                                    <div style={{fontWeight:500}}>{used}/{item.benefits[0].initialVal} {item.benefits[0].unit}</div>
                                </div>
                                <div className="progress my-1" style={{height: 10}}>
                                    <div className="progress-bar" role="progressbar" style={{width: widthFromVar,backgroundColor: '#0049A5'}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"> </div>
                                </div>
                                {/* <div style={{fontSize:10, color: '#0049A5',fontWeight:500}}>{widthFromVar} used</div> */}
                                <div className="pt-2 text-center" style={{ color: '#407CCA', fontWeight: 600, fontSize: 12, borderTop: '1px solid #eaedf0', cursor: 'pointer', marginTop: 10}}
                                    onClick={(event) => { this.allUsageInfoClicked(item.planId, "addon",event) }}>
                                    {this.props.locales.viewAllUsageInfoSectionHeadingGsm}
                                </div>
                        </div>
                        : null }

                    </div>
                </div>
            );
        })
        if (this.state.allAddonArray.length > 0) {
            return (allAddons)
        } 
    }

    populateAllUsageDetails(){
        if(this.state.bucketDetailsType === "addon") {
            for(var i=0; i< this.state.allAddonArray.length; i++){
                if(this.state.allAddonArray[i].planId === this.state.receivedUsageAddonId){
                    var currentAddon = this.state.allAddonArray[i]
                    const allUsage = currentAddon.benefits.map((item, key) => {

                        //display bucket name from config
                        var usageName = item.usageName;
                        const displayName = this.state.selfcareBucketNames.find(item => 
                            item.ORIGINAL_NAME.toLowerCase() === usageName.toLowerCase()
                           );
                        if (displayName) {
                            const newName = displayName.DISPLAY_NAME;
                            usageName = newName
                        } 

                        var widthFromVar = 0;
                        var used = 0;
                            used = parseFloat(item.initialVal) - parseFloat(item.val)
                            widthFromVar = ((parseFloat(used) / parseFloat(item.initialVal)) * 100) + "%"
                            if(typeof used === 'number' && (used % 1) === 0) {
                                // data is an integer
                            } else {
                                used = GeneralUtils.formatNumberToStandardFormWithoutComma(used)
                            }
                            if(item.initialVal === "UNLIMITED" && item.val === "UNLIMITED"){
                                used= "UNLIMITED";
                                widthFromVar="100%";
                            }
                        return(
                        <div className="pb-4" key={key}>
                            <div className="pb-1" style={{color: '#231F20', fontSize: 16}}>{usageName}</div>
                            <div className="d-flex justify-content-between" style={{fontSize:12,color:'#0049A5'}}>
                                <div>{this.props.locales.usageSecHeadingInAllAddons}</div>
                                <div style={{fontWeight:500}}>{used}/{item.initialVal} {item.unit}</div>
                            </div>
                            <div className="progress my-1" style={{height: 10}}>
                                <div className="progress-bar" role="progressbar" style={{width: widthFromVar,backgroundColor: '#0049A5'}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"> </div>
                            </div>
                            {/* <div style={{fontSize:10, color: '#0049A5',fontWeight:500}}>{widthFromVar} used</div> */}
                        </div>
                        )
                    })
                    return (allUsage)
                }
            }
        } else if(this.state.bucketDetailsType === "basePlan"){
            const allUsage = this.state.basePlanDetailsObj.benefits.map((item, key) => {

                //display bucket name from config
                //display bucket name from config
                var usageName = item.usageName;
                const displayName = this.state.selfcareBucketNames.find(item => 
                    item.ORIGINAL_NAME.toLowerCase() === usageName.toLowerCase()
                   );
                if (displayName) {
                    const newName = displayName.DISPLAY_NAME;
                    usageName = newName
                } 

                var widthFromVar = 0;
                var used = 0;
                    used = parseFloat(item.initialVal) - parseFloat(item.val)
                    widthFromVar = ((parseFloat(used) / parseFloat(item.initialVal)) * 100) + "%" 
                    if(typeof used === 'number' && (used % 1) === 0) {
                        // data is an integer
                    } else {
                        used = GeneralUtils.formatNumberToStandardFormWithoutComma(used)
                    }
                   
                    if(item.initialVal === "UNLIMITED" && item.val === "UNLIMITED"){
                        used= "UNLIMITED";
                        widthFromVar="100%";
                    }
                return(
                <div className="pb-4" key={key}>
                    <div className="pb-1" style={{color: '#231F20', fontSize: 16}}>{usageName}</div>
                    <div className="d-flex justify-content-between" style={{fontSize:12,color:'#0049A5'}}>
                        <div>{this.props.locales.usageSecHeadingInAllAddons}</div>
                        <div style={{fontWeight:500}}>{used}/{item.initialVal} {item.unit}</div>
                    </div>
                    <div className="progress my-1" style={{height: 10}}>
                        <div className="progress-bar" role="progressbar" style={{width: widthFromVar,backgroundColor: '#0049A5'}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"> </div>
                    </div>
                    {/* <div style={{fontSize:10, color: '#0049A5',fontWeight:500}}>{widthFromVar} used</div> */}
                </div>
                )
            })
            return (allUsage)
        }
    }

    myCallback = (isPaymentComponentEnabled, isReceiptModalVisible, transactionId, finalRechargeAmount) => {
        this.setState({
            isRechargeComponentVisible: isPaymentComponentEnabled,
            isReceiptModalVisible: isReceiptModalVisible,
            transactionId: transactionId,
            finalRechargeAmount: finalRechargeAmount
        })
    }

    receiptCallback = () => {
        this.setState({
            isReceiptModalVisible: false
        })
        this.initialiseSubscriberInfo();
    }

    populateContractDetails(receivedResponse) {
        if (receivedResponse && receivedResponse.BillingSystem &&
            receivedResponse.BillingSystem.response && receivedResponse.BillingSystem.response.dataset &&
            receivedResponse.BillingSystem.response.dataset.contract_plan) {
            var contractDetailsArray = receivedResponse.BillingSystem.response.dataset.contract_plan;
            for (var i = 0; i < contractDetailsArray.length; i++) {
                if (contractDetailsArray[i].contract_type === "2") {
                    var dateFrom = GeneralUtils.formatDateToStandardForm(contractDetailsArray[i].activation_date, this.props.configurationValues.dateFormatForBilling);
                    var dateTo = GeneralUtils.formatDateToStandardForm(contractDetailsArray[i].expiry_date, this.props.configurationValues.dateFormatForBilling);
                    //var dateTo = "03/30/2021"
                    var isContractExpired = false;
                    if (moment(dateTo, this.props.configurationValues.dateFormatForBilling, "MM-DD-YYYY").diff(moment().format("MM-DD-YYYY"), 'days') < 0) {
                        isContractExpired = true;
                    }
                    this.setState({
                        serviceContractDateFrom: dateFrom,
                        serviceContractDateTo: dateTo,
                        contractId: contractDetailsArray[i].contract_id,
                        isContractExpired: isContractExpired
                    })
                }
            }
        }
    }

    initialiseServiceAddress() {
        var currentService = this.props.currentServiceDetails.serviceAddress
        this.state.addressLine1 = currentService.AddressLine1;
        this.state.addressLine2 = currentService.AddressLine2;
        this.state.city = currentService.city;
        this.state.state = currentService.state;
        this.state.zip = currentService.zip;
        this.state.serviceId = currentService.serviceId;
        this.state.isServiceFeasible = currentService.isServiceFeasible;
        this.state.profileId = currentService.profileId;
        this.state.connectionType = currentService.connectionType;
        if (currentService.connectionType === "1") {
            this.setState({ isPrepaidService: false })
        } else {
            this.setState({ isPrepaidService: true })
        }

        this.setState({ "dummy": "dummy" })
    }

    handleInputValueChange(name, event, type) {
        if (type === "checkbox") {
            const value = event.target.checked;
            this.state[name] = value;
        } else {
            this.state[name] = event;
        }

        if(name === "transactionHistoryDateFrom"){
            this.state.maxDateForTransactionHistory = moment(this.state.transactionHistoryDateFrom).endOf('month').format("MM-DD-YYYY")
            this.state.transactionHistoryDateTo = new Date(this.state.maxDateForTransactionHistory)
        }

        this.setState({ dummy: "dummy" })
    };

    loyaltyTransferHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ isLoyaltySliderVisible: false })
        } else if (dataObject.type === "submit") {
            document.body.classList.remove('modal-open');
            this.setState({ isLoading: true })
            var mobileNum = this.state.phoneNumForLoyaltyTransfer.replace(/\D/g, "");
            var dataToSend = {
                "serviceId": this.state.userDetails.service_id,
                "toServiceId": mobileNum,
                "loyaltyPoints": this.state.rangeVal
            }
            Network.executeAxios("loyaltyTransferPoint", "POST", dataToSend, (loyaltyTransferResponse) => {
                if (loyaltyTransferResponse && loyaltyTransferResponse.statusCode) {
                    var statusCode = loyaltyTransferResponse.statusCode
                    var statusDescription = loyaltyTransferResponse.statusDescription
                    if (statusCode === "SC0000") {
                        Swal.fire({
                            title: "Loyalty Points Transferred Successfully",
                            text: "",
                            type: '',
                            showCancelButton: false,
                            confirmButtonText: 'Ok'
                        }).then((result) => {
                            if (result.value) {
                                this.initialiseRewardPoints()
                                this.setState({ isPopupVisible: true })
                                this.setState({ popupContent: this.state.rangeVal + " " + "Loyalty points has been transfered" })
                            }
                        });
                    } else {
                        Swal.fire(statusDescription, "", "")
                    }
                }
                this.setState({ isLoading: false, isLoyaltySliderVisible: false })
            })
        }
    }

    callMeBackModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ isCallMeBackModalVisible: false })
        } else if (dataObject.type === "submit") {
            if (ValidateForm.inputFieldMandatoryCheck("callMeBackContainer", this.props.locales, false)) {
                if (ValidateForm.inputFieldValueCompositionCheck("callMeBackContainer", this.props.locales, false)) {
                    document.body.classList.remove('modal-open');
                    var mobileNum = this.state.callMeBackVal.replace(/\D/g, "");
                    this.setState({ isLoading: true })
                    Network.executeAxios("callMeBack", "POST", { "serviceId": this.state.userDetails.service_id, "bParty": mobileNum }, (callMeBackResponse) => {
                        this.setState({ isCallMeBackModalVisible: false, isLoading: false });
                        if (callMeBackResponse && callMeBackResponse.resultParam && callMeBackResponse.resultParam.resultCode) {
                            var resultCode = callMeBackResponse.resultParam.resultCode;
                            var resultDesc = callMeBackResponse.resultParam.resultDescription
                            if (resultCode === "1169") {
                                Swal.fire({
                                    title: this.props.locales.callMeBackSuccessMsgInSwal,
                                    text: this.props.locales.weHaveSentCallBackReqInGsmCallMeBack + " " + this.state.callMeBackVal + " " + this.props.locales.viaSmsSwalTxtInCallMeBack,
                                    type: '',
                                    showCancelButton: false,
                                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                                }).then((result) => {
                                    document.body.classList.remove('modal-open');
                                });
                            } else {
                                Swal.fire(resultDesc, "", "");
                            }
                        } else {
                            Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                        }
                    })

                }
            }
        }
    }

    rewardsTAndCModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ rewardsTermsAndConditionsVisible: false })
        } else if (dataObject.type === "submit") {
            Network.executeAxios("loyalityUserRegistration", "POST", { "serviceId": this.state.userDetails.service_id, "customerName": this.state.customerName, "contactNumber": this.state.contactNumber }, (receivedResponse) => {
                if (receivedResponse.result_code === "0") {
                    this.setState({ isAlreadyRegisteredForRewards: true })

                    // } else if (receivedResponse.STATUS == "NotAvailable") {
                    //     this.setState({ isAlreadyRegisteredForRewards: false })
                    //     Swal.fire("Loyality registration not available at the moment", "", "");
                    //     document.body.classList.remove('modal-open');
                    //     this.setState({ rewardsTermsAndConditionsVisible: false })

                    Swal.fire({
                        title: "Loyality Registration Success",
                        text: "",
                        type: '',
                        timer: 2000,
                        showCancelButton: false,
                        confirmButtonText: 'Ok',
                    }).then((result) => {
                        document.body.classList.remove('modal-open');
                        this.setState({ rewardsTermsAndConditionsVisible: false })
                        this.getRewardPoints();
                    });


                } else {
                    this.setState({ isAlreadyRegisteredForRewards: false })
                    Swal.fire(this.props.locales.loyaltyRegFailureSwal);
                    document.body.classList.remove('modal-open');
                }
            })
        }
    }

    redeemRewardsModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ redeemRewardsModalVisible: false })
        }
    }

    transactionsRewardsModalHandler = (dataObject) => {
        if (dataObject.type === "cancel") {
            document.body.classList.remove('modal-open');
            this.setState({ transactionsRewardsModalVisible: false })
        }
    }
    generateUniqueRequestId = () => {
        var requestId = "SCM" + "1" + moment().valueOf() + Math.floor(10 + Math.random() * 90);
        //Request ID format -  SCM + 1 + 15 digit sequence number 
        return requestId;
    };


    rewardsRedeemBtnClicked = (rewardPoints,currentAddonData) => {
        var offerDetails = JSON.parse(decodeURIComponent(currentAddonData));
        console.log("offerDetails>>>>",offerDetails)
        this.setState({ isLoading: true })
        var requestId = this.generateUniqueRequestId();
        var dataToSend = {
            "requestId": requestId,
            "serviceId": this.state.userDetails.service_id,
            "rewardPoints": rewardPoints,
            "productId": offerDetails.id,
            "productName": offerDetails.name
        }
        Network.executeAxios("reservePoints", "POST", dataToSend, (reserveResponse) => {
           if(reserveResponse.respCode == "SC0000"){
                this.generateAddonFinalRequest(requestId,offerDetails,rewardPoints);
           } else {
                this.setState({ isLoading: false })
                Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
           }
        })
    }

    generateAddonFinalRequest(requestId, receivedAddonDetails,rewardPoints) {
        var servicesSubscription = [];
        var effective_date = receivedAddonDetails.effective_date;
        var effective_date_formatted = ""
        if (effective_date !== "" && effective_date !== undefined) {
            effective_date_formatted = effective_date;
        }
        else {
            effective_date_formatted = moment().format(this.props.configurationValues.dateFormatForBilling)
        }

        var expiry_date = receivedAddonDetails.expiry_date;
        var expiry_date_formatted = ""
        if (expiry_date != "" && expiry_date != undefined) {
            expiry_date_formatted = expiry_date;
        }
        else {
            expiry_date_formatted = moment().add(103, 'years').format(this.props.configurationValues.dateFormatForBilling)
        }
        var addonsSubscriptions =
        {
            "product_id": receivedAddonDetails.productId,
            "product_name": receivedAddonDetails.productName,
            "plan_id": receivedAddonDetails.id,
            "plan_name": receivedAddonDetails.name,
            "plan_desc": receivedAddonDetails.description,
            "effective_date": effective_date_formatted,
            "expiry_date": expiry_date_formatted,
            "is_base_plan": "0",
            "po_type": receivedAddonDetails.poType,
            "po_sub_type": "0",
            "subscription_type": "0",
            "subscription_charges": receivedAddonDetails.subscriptionCharges,
            "cfss": receivedAddonDetails.cfss,
            "pogIdFromResponse": receivedAddonDetails.pogIdFromResponse,
            "apply_purchase_fee":"false",
            "activate_addon_upon_use": "false",
            "status": "0",
            "plan_type": "2",
            "version": "3"
        }
        servicesSubscription.push(addonsSubscriptions);

        var finalOrderReq = {
            "order_information": {
                "order_type": "AddSubscription",
                "customer_name": this.state.customerName,
                "contact_number": this.state.contactNumber,
                "service_management": {
                    "service_id": this.state.userDetails.service_id,
                    "profile_id": this.state.profileId,
                    "account_id": this.state.accountId,
                    "service_name": this.state.userDetails.service_name,
                    "service_code": this.state.serviceCode,
                    "subscriptions": servicesSubscription,
                    "service_address": {
                        "addr_line1": this.props.cache.serviceListResponse[0].addresses[0].addr_line1,
                        "addr_line2": this.props.cache.serviceListResponse[0].addresses[0].addr_line2,
                        "addr_line3": this.props.cache.serviceListResponse[0].addresses[0].addr_line3,
                        "addr_line4": this.props.cache.serviceListResponse[0].addresses[0].addr_line4,
                        "addr_line5": this.props.cache.serviceListResponse[0].addresses[0].addr_line5,
                        "addr_line6": ""
                    }
                },
                "dataset": {
                    "param": [
                        {
                            "id": "entity_id",
                            "value": "200"
                        }
                    ]

                }
            }
        }

        if (parseInt(rewardPoints) > 0) {
            finalOrderReq["order_information"]["service_management"]["loyalty_info"] = {
                "lms_txn_id": requestId
            }
        }

        var addSubscriptionDataToSend = {
            "finalReq": finalOrderReq
        }
     
        Network.executeAxios("addSubscription", "POST", addSubscriptionDataToSend, (response) => {
            this.handleAddSubscriptionResponse(requestId, receivedAddonDetails.name, response);
        });
    }

    handleAddSubscriptionResponse(requestId, planName, response) {
        var isSuccess = false;
        try {
            if (response.result_code == "0") {
                isSuccess = true;
            }
        } catch (err) { isSuccess = false }
        if (isSuccess) {
            Network.executeAxios("commitPoints", "POST", {requestId : requestId, planName : planName, serviceId : this.state.userDetails.service_id }, (commitResponse) => {
                this.setState({ isLoading: false })
                if(commitResponse.respCode == "SC0000"){
                    Swal.fire({
                        title: this.props.locales.rewardsRedeemPlanSuccessText,
                        type: '',
                        showCancelButton: false,
                        confirmButtonText: 'Ok'
                    }).then((result) => {
                        if (result.value) {
                            document.body.classList.remove('modal-open');
                            this.setState({ redeemRewardsModalVisible: false })
                            window.location.reload();
                        }
                    });
                }else {
                    Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
                }
             })
        } else {
            Network.executeAxios("rollbackPoints", "POST", {requestId : requestId, serviceId : this.state.userDetails.service_id }, (rolbackResponse) => {
                this.setState({ isLoading: false })
                if(rolbackResponse.respCode == "SC0000"){
                    // Swal.fire({
                    //     title: this.props.locales.rewardsRedeemPlanSuccessText,
                    //     type: '',
                    //     showCancelButton: false,
                    //     confirmButtonText: 'Ok'
                    // }).then((result) => {
                    //     if (result.value) {
                    //         document.body.classList.remove('modal-open');
                    //         this.setState({ redeemRewardsModalVisible: false })
                    //         window.location.reload();
                    //     }
                    // });
                    console.log("rollback success");
                    Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
                }else {
                    console.log("rollback failed");
                    Swal.fire(this.props.locales.rewardsRedeemPlanFailedText, "", "");
                }
             })
        }
    }

    generalButtonsClicked(type) {
        this.props.setRegisterDetails("generalResponse.type", type)
        var dataToSend = {
            "serviceId": this.props.currentServiceDetails.currentServiceId
        }
        if (type === "viewCallDetails") {
            Swal.fire(this.props.locales.myaccountIneternetClickedViewSwal, "", "");
        } else if (type === "disableVoiceMail") {
            Swal.fire(this.props.locales.myAccountInternetClickedDisableSwal, "", "");
        } else if (type === "changePlan") {
            dataToSend["actionType"] = "change_plan";
            this.eligibilityAndFeasibilityCheck(dataToSend, "changePlan")
        } else if (type === "addAddon") {
            dataToSend["actionType"] = "add_on_add";
            this.eligibilityAndFeasibilityCheck(dataToSend, "addAddon")
        } else if (type === "addFnF") {
            dataToSend["actionType"] = "add_on_add";
            this.eligibilityAndFeasibilityCheck(dataToSend, "addFnF")
        } else if (type === "closeUsageModal") {
            this.setState({ isViewUsageInfoModalVisible: false })
        }

    }

    eligibilityAndFeasibilityCheck(dataToSend, type) {
        this.setState({ isLoading: true })
        var isEligible = "true";
        // Network.executeAxios("pendingOrderEligibility", "POST", { "serviceId": this.props.currentServiceDetails.currentServiceId }, (pendingOrderResponse) => {
        //     if (pendingOrderResponse && pendingOrderResponse.eligiblity_results && pendingOrderResponse.eligiblity_results.order_eligibility
        //         && pendingOrderResponse.eligiblity_results.order_eligibility.is_eligible) {
        //         isEligible = pendingOrderResponse.eligiblity_results.order_eligibility.is_eligible;
        //     } else {
        //         this.setState({ isLoading: false })
        //         Swal.fire(this.props.locales.internalErrorTitleInSwal)
        //     }
        //     if (isEligible === "false") {
        //         this.setState({ isLoading: false })
        //         Swal.fire(this.props.locales.pendingOrderExistSwalTitle);
        //     }
            if (isEligible === "true") {
                Network.executeAxios("eligibilityValidation", "POST", dataToSend, (validationResponse) => {
                    if (validationResponse && validationResponse.BillingSystem && validationResponse.BillingSystem.response
                        && validationResponse.BillingSystem.response.optionlist[0] && validationResponse.BillingSystem.response.optionlist[0].response_code) {
                        var resultCode = validationResponse.BillingSystem.response.optionlist[0].response_code;
                        var resultDesc = validationResponse.BillingSystem.response.optionlist[0].response_description
                        if (resultCode === "0") {
                            Network.executeAxios("fetchIgnorePlanDetails", "POST", dataToSend, (ignoredPlanResponse) => {
                                var ignoredPlanArr = []
                                if(ignoredPlanResponse && ignoredPlanResponse[0]){
                                    for(var h=0; h< ignoredPlanResponse.length; h++){
                                        ignoredPlanArr.push(ignoredPlanResponse[h].PLAN_NAME)
                                    }
                                }
                                this.props.setRegisterDetails("ignorePlanIds", ignoredPlanArr);
                                window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                                this.props.setRegisterDetails("services", this.state.currentService);
                                this.props.setRegisterDetails("givenAddress", this.props.currentServiceDetails.serviceAddress);
                                if (type === "changePlan") {
                                    this.props.setRegisterDetails("generalResponse.planComparisonData.currentAddonDetails", []);
                                    this.props.setRegisterDetails("customize.addons", []);
                                    this.getContractViolationPrice();
                                } else if (type === "addAddon") {
                                    this.setState({ isLoading: false })
                                    this.props.setRegisterDetails("activeAddons", this.state.allAddonArray);
                                    this.props.setCurrentPage("pageName", "addons");
                                    this.setState({ redirectToAddSubscription: true })
                                    this.props.setRegisterDetails("customize.addons", []);
                                } else if (type === "addFnF") {
                                    this.setState({ isFriendsAndFamilySectionVisible: true })
                                }
                            })
                        } else {
                            this.setState({ isLoading: false })
                            Swal.fire(resultDesc, "", "");

                        }
                   
                    } else {
                        this.setState({ isLoading: false })
                        Swal.fire(this.props.locales.LoginPageUnableToProcessSwal, "", "");
                    }
                })
            }
        //})
    }

    getContractViolationPrice() {
        if (this.state.isContractExpired) {
            this.setState({ isLoading: false })
            this.props.setCurrentPage("pageName", "services");
            this.props.setRegisterDetails("offers", {});
            this.setState({ redirectToAddSubscription: true })
            this.props.setRegisterDetails("activeAddons", this.state.allAddonArray);
        } else {
            var contractViolationCharge = {}
            Network.executeAxios("getETF", "POST", "", (response) => {
                this.setState({ isLoading: false })
                var price = 0;
                if (response[0] && response[0].price) {
                    price = response[0].price;
                    contractViolationCharge = response[0];
                }

                Swal.fire({
                    title: this.props.locales.contractViolationChargeInSwal,
                    html: `<div>As your current offer is under a active contract, Upgrade or change offer will violate the contract policy and a charge $${price} will be applicable in the bill total </div><div className="pt-4"><b>Would you like to continue ?</b></div>`,
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.props.setRegisterDetails("contractDetails", contractViolationCharge)
                        this.props.setCurrentPage("pageName", "services");
                        this.props.setRegisterDetails("offers", {});
                        this.setState({ redirectToAddSubscription: true })
                        this.props.setRegisterDetails("activeAddons", this.state.allAddonArray);
                    }
                });
            })
        }
    }

    tabLinkClicked() {
        this.setState({ redirectToMyAccount: true })
    }

    loyaltyTransactionTableHandler = (dataObject) => {
        if (dataObject.type === "firstTimeLoad" || dataObject.type === "pagination") {
            this.setState({ "dummy": "dummy" });
        }
    }

    loyaltyTransferClicked(type) {
        if (type === "transfer") {
            this.setState({
                tab: "transfer",
                loyaltyTransferTab: true,
                transactionHistoryTab: false,
                phoneNumForLoyaltyTransfer: "",
                rangeVal: "1"
            })
        } else {
            this.setState({
                tab: "loyaltyTransactionHistory",
                loyaltyTransferTab: false,
                transactionHistoryTab: true
            })
        }

        this.setState({ isLoading: true })
        Network.executeAxios("loyaltyTransactionDetails", "POST", { "serviceId": this.state.userDetails.service_id }, (loyaltyTransactionDetailsResponse) => {
            this.initialiseLoyaltyTransaction(loyaltyTransactionDetailsResponse);
            this.setState({ isLoading: false })
        })

        this.setState({ isLoyaltySliderVisible: true })
    }

    initialiseLoyaltyTransaction(loyaltyTransactionDetailsResponse) {
        var loyaltyTransactions = []
        if (loyaltyTransactionDetailsResponse && loyaltyTransactionDetailsResponse.transactionDetails) {
            loyaltyTransactions = loyaltyTransactionDetailsResponse.transactionDetails
        }

        var finalLoyaltyArray = []
        for (var i = 0; i < loyaltyTransactions.length; i++) {
            var currentObj = loyaltyTransactions[i]
            var isCredited = true;
            var typeFromLms = "NA"
            if (currentObj && currentObj.type) {
                typeFromLms = currentObj.type
                if (currentObj.type.toUpperCase() === "POINTS TRANSFERED" || currentObj.type.toUpperCase() === "REDEMPTION") {
                    isCredited = false;
                }
            }

            var toServiceId = ""
            if (currentObj.toServiceId) {
                toServiceId = GeneralUtils.formatPhoneNumberToUsFormatNew(currentObj.toServiceId);
            }
            if (currentObj)
                var temp = {
                    "isCredited": isCredited,
                    "date": GeneralUtils.formatDateToStandardForm(currentObj.date, "DD-MM-YYYY HH:mm:ss"),
                    "transactionType": typeFromLms,
                    "loyaltyPoints": currentObj.loyaltyPoints,
                    "toServiceId": toServiceId
                }
            finalLoyaltyArray.push(temp)
        }

        console.log("finalLoyaltyArray>>>", finalLoyaltyArray)
        var loyaltyTransactionsPayload = {
            totalRecords: loyaltyTransactionDetailsResponse.totalCount,
            data: finalLoyaltyArray
        }
        this.setState({ loyaltyTransactionsPayload: loyaltyTransactionsPayload })
    }

    quickLinkClicked(type) {
        if (type === "loan") {
            Swal.fire({
                title: this.props.locales.loanAmountInGsmPart + this.state.loanAmount + this.props.locales.creditedBalanceInGsmPart,
                text: this.props.locales.loanPayBackTextInSwal,
                type: '',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.setState({ isLoading: true })
                    Network.executeAxios("loanRequest", "POST", { "serviceId": this.state.userDetails.service_id, "amount": this.state.loanAmount }, (loanRequestResponse) => {
                        this.setState({ isLoading: false });
                        if (loanRequestResponse && loanRequestResponse.resultParam && loanRequestResponse.resultParam.resultCode) {
                            var resultCode = loanRequestResponse.resultParam.resultCode;
                            var resultDesc = loanRequestResponse.resultParam.resultDescription
                            if (resultCode === "1138") {
                                Swal.fire({
                                    title: this.props.locales.loanReqSuccessMsgInSwal,
                                    text: "",
                                    type: '',
                                    showCancelButton: false,
                                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                                }).then((result) => {
                                    document.body.classList.remove('modal-open');
                                    if (result.value) {
                                        this.initialiseSubscriberInfo();
                                    }
                                });
                            } else {
                                Swal.fire(resultDesc, "", "");
                            }
                        } else {
                            Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                        }
                    })
                }
            });
        } else if (type === "callMeBack") {
            document.body.classList.add('modal-open');
            this.setState({ isCallMeBackModalVisible: true })
        } else if (type === "recharge") {
            this.setState({ isRechargeComponentVisible: true })
        } else if (type === "fnf") {
            if (this.state.planIdForFnF !== "" && this.state.isFnFAdded === "true") {
                this.generalButtonsClicked("addFnF");
            } else if (this.state.isFnFAdded === "false" && this.props.locales.enableFnFAddonActivation === "true") {
                this.generalButtonsClicked("addFnF");
            } else if (this.state.isFnFAdded === "false" && this.props.locales.enableFnFAddonActivation === "false") {
                Swal.fire(this.props.locales.fnfAddonIsNotActivatedSwalMsg)
            } else { Swal.fire(this.props.locales.internalErrorTitleInSwal) }

        }
        this.setState({ "dummy": "dummy" })
    }

    closePopup() {
        this.setState({ isPopupVisible: false })
    }

    switchAccountLink() {
        this.props.setSwitchAccountModalTrue();
    }

    tablinkClickedForLoyalty(type) {
        if (type === "transfer") {
            this.setState({
                tab: type,
                loyaltyTransferTab: true,
                transactionHistoryTab: false
            });
        } else {
            this.setState({
                tab: type,
                loyaltyTransferTab: false,
                transactionHistoryTab: true
            });
        }
    }

    rewardsRegisterBtnClicked = () => {
        document.body.classList.add('modal-open');
        this.setState({ rewardsTermsAndConditionsVisible: true })
    }

    transactionsRewardsBtnClicked = () => {
        document.body.classList.add('modal-open');
        this.setState({ transactionsRewardsModalVisible: true })
    }

    toggleNotificationVoice = () => {
        Swal.fire({
            title: this.props.locales.SettingsCompChangeStatusSwal,
            text: '',
            type: '',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.value) {
                var status="true";
                if(this.state.notificationVoice) status = "false"
                    const dataToSend = {
                        status: status,
                        serviceId: this.props.currentServiceDetails.currentServiceId
                    };
                  
                    this.setState({ isLoading: true })
                    Network.executeAxios("updateHlrStatus", "POST", dataToSend, (response) => {
                        var isSuccess = false;
                        if (response && response.statusCode && response.statusCode === "SC0000") {
                            isSuccess = true;
                        }

                        if (isSuccess) {
                            this.setState({
                                isLoading: false
                            })
                            Swal.fire({
                                title: this.props.locales.SettingsCompNotificationSuccessSwal,
                                text: '',
                                type: '',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                            }).then((result) => {
                                if (result.value) {
                                    this.setState({ isLoading: true })
                                    Network.executeAxios("fetchHlrStatus", "POST", {"serviceId": this.props.currentServiceDetails.currentServiceId} , (HLRstatusResponse) => {
                                        this.manageHlrStatus(HLRstatusResponse,true);
                                    })
                                }
                            });
                        } else {
                            this.setState({ isLoading: false });
                            Swal.fire(this.props.locales.SettingsCompNotificationFailSwal);
                        }
                    });
            }
        })
    };


    render() {
        if (this.state.redirectToAddSubscription) {
            return (
                <ActivateAddonRootComponent />
            )
        }

        if (this.state.redirectToMyAccount) {
            return (
                <MyAccountComponent />
            )
        }

        if (this.state.isFriendsAndFamilySectionVisible) {
            return (
                <FriendsAndFamilyComponent serviceId={this.props.currentServiceDetails.currentServiceId} isFnFAdded={this.state.isFnFAdded} allCurrentPlanDetails={{ profileId: this.state.profileId, serviceAddress: this.props.currentServiceDetails.serviceAddress, currentService: this.state.currentService, allAddonArray: this.state.allAddonArray, planIdForFnF: this.state.planIdForFnF, activationDateForFnF: this.state.activationDateForFnF, addonExpiryDate: this.state.addonExpiryDate }} />
            )
        }


        return (
            <div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : this.componentContent()}
            </div>
        );
    }

    componentContent() {
        var widthFromVar = 0;
        var used = 0;
        if(this.state.basePlanDetailsObj.benefits.length > 0){
            used = parseFloat(this.state.basePlanDetailsObj.benefits[0].initialVal) - parseFloat(this.state.basePlanDetailsObj.benefits[0].val)
            if(typeof used === 'number' && (used % 1) === 0) {
                // data is an integer
            } else {
                used = GeneralUtils.formatNumberToStandardFormWithoutComma(used)
            }
            widthFromVar = ((parseFloat(used) / parseFloat(this.state.basePlanDetailsObj.benefits[0].initialVal)) * 100) + "%"
           
            if(this.state.basePlanDetailsObj.benefits[0].initialVal === "UNLIMITED" && this.state.basePlanDetailsObj.benefits[0].val === "UNLIMITED"){
                used= "UNLIMITED";
                widthFromVar="100%";
            }
        }

        return (
            <div id="myAccountInternetTopDivContainer" className="animated fadeIn px-sm-5 px-0">
                {this.state.isPopupVisible ?
                    <div className={this.state.isPopupVisible ? "col-12 animated fadeIn row popupFoSuccess" : "col-12 animated fadeOut row popupFoSuccess"} style={{ zIndex: 10 }}>
                        <div className="col-12 d-flex justify-content-between align-items-center">
                            {this.state.popupContent}
                            <div> <IoMdClose style={{ cursor: 'pointer' }} onClick={() => this.closePopup()} /></div>
                        </div>
                    </div>
                    : null}
                <div className="d-md-flex justify-content-between px-4 mt-5 pt-sm-0 pt-3 myAccountGsmTopContainer" style={{ position: 'relative' }}>
                    <div className="text-left pl-2">
                        <div className="" style={{ color: '#231F20', fontSize: 24, fontWeight: 500 }}>{this.props.locales.servicesTextForTabLinkManageService}</div>
                        <div className="d-flex mb-0" style={{ color: '#231F20' }}>
                            <div className="" style={{ cursor: 'pointer', fontSize: 18, fontWeight: 400 }} onClick={() => this.tabLinkClicked('myAccount')}>{this.props.locales.myAccountTextInTabLinkManageService}</div>
                            <div className="ml-3" style={{ cursor: 'pointer', fontSize: 18, fontWeight: 600 }}> > &nbsp;{this.props.locales.manageServiceTextInTabLinkManageService}</div>
                        </div>
                    </div>


                        {/* change position */}
                        <div className="text-md-right pr-2 pt-sm-1 pt-4">
                            <div className="my-auto"> {this.state.notificationVoice ? this.props.locales.disableVoiceMailtxtInSettings : this.props.locales.enableVoiceMailtxtInSettings}</div>
                            <div className="col-md-8 py-3 d-flex ml-auto">
                                <Switch onClick={this.toggleNotificationVoice} on={this.state.notificationVoice} />
                            </div>
                        </div>

                    {/* hiding reward points */}
                    {this.state.isAlreadyRegisteredForRewards ?
                        <div className="text-md-right pr-2 pt-sm-1 pt-4">
                            <div>
                                <div style={{ fontSize: 14, fontWeight: 600, color: '#231F20' }}>Total Reward Points</div>
                                <div style={{ fontSize: 30, color: '#231F20', fontWeight: 400 }}>{this.state.rewardPointsFromLMS}</div>
                                <div style={{ fontWeight: 500, fontSize: 12, color: '#407CCA' }} ><span style={{ cursor: 'pointer' }} onClick={() => this.redeemRewardsBtnClicked()}>Redeem Rewards</span>&nbsp; | &nbsp; <span style={{ cursor: 'pointer' }} onClick={() => this.transactionsRewardsBtnClicked()}>Transactions</span></div>
                            </div>
                        </div>
                        :
                        <div className="text-md-right pr-2 pt-sm-1 pt-4">
                            <div style={{ fontSize: 14, fontWeight: 600, color: '#231F20' }}>Register for APUA inet's rewards program</div>
                            <Button className="registerButton px-sm-5 px-3 mt-2" onClick={() => { this.rewardsRegisterBtnClicked() }} >
                                Register
                            </Button>
                        </div>
                    }


                    {/* {parseInt(this.state.rewardPointsFromLMS) > 0 ?
                        <div className="text-md-right pr-2 pt-sm-1 pt-4">
                            <div style={{ fontSize: 14, fontWeight: 600, color: '#231F20' }}><span><button className="tooltipContainer" id="rewardPointsInfoTooltip"><img src={infoIcon} alt="" /></button></span>{this.props.locales.totalRewardPointsHeadingInManageService} &nbsp;</div>
                            <div style={{ fontSize: 30, color: '#231F20', fontWeight: 400 }}>{this.state.rewardPointsFromLMS}</div>
                            <Tooltip placement="top" isOpen={this.state.isRewardInfoTooltipOpen} target="rewardPointsInfoTooltip" toggle={() => { this.setState({ isRewardInfoTooltipOpen: !this.state.isRewardInfoTooltipOpen }) }}>
                                {this.props.locales.rewardPointsInfoTooltipText}
                            </Tooltip>
                            <div style={{ fontWeight: 500, fontSize: 12, color: '#407CCA' }} ><span style={{ cursor: 'pointer' }} onClick={() => this.loyaltyTransferClicked("transfer")}>{this.props.locales.transferPointsInGsmPart}</span>&nbsp; | &nbsp; <span style={{ cursor: 'pointer' }} onClick={() => this.loyaltyTransferClicked("transactionDetails")}>{this.props.locales.viewTransactionHistoryInGsmPart}</span></div>
                        </div>
                        : null} */}
                    {this.state.isPopupContainerVisible ?
                        <div className={this.state.isPopupVisible ? " animated fadeIn " : " animated fadeOut "} style={{ position: 'absolute', right: 0, fontWeight: 500, padding: '18px 30px', borderRadius: 5, color: '#ffffff', boxShadow: '0 2px 10px 0 rgba(0,0,0,0.1)', backgroundColor: 'rgba(0,213,128,0.9)', height: 85, width: 420 }}>{this.props.locales.requestForPhnNumChangePopopTxtMyAccountGsm}</div>
                        : null}
                </div>
                <div className="col-md-12 d-flex row m-0 justify-content-between">
                    <div className="col-lg-8 mt-4" >
                        <div className="py-3 px-sm-3 px-0 myAccountServicesOuterBox">
                            <div className="col-md-12 d-flex row m-0 p-0 mt-2 justify-content-between">
                                <div className="col-md-6  p-0" >
                                    <div className="myAccountHeadingText mb-2" style={{ marginTop: -10 }}>{this.props.locales.myAccountInternetMyServiceTxt}</div>
                                    <div className="col-md-12 myAccountsServicesBox pb-2 p-0" style={{ height: 185 }}>
                                        <div className="col-md-12">
                                            <div className="col-md-12 p-0" >
                                                {this.state.userDetails.status === "1"
                                                    ?
                                                    <div className="serviceStatus px-2 col-md-5 p-0 m-0 text-center mx-auto" style={{ height: 23, width: '34%' }} >{this.props.locales.activeServiceStatusInOverview}</div>
                                                    :
                                                    null
                                                }
                                                {this.state.userDetails.status === "0"
                                                    ?
                                                    <div className="serviceStatus_inactive px-2 col-md-5 p-0 m-0 text-center mx-auto" style={{ height: 23, width: '34%' }} >{this.props.locales.preActiveServiceStatusInOverview}</div>
                                                    :
                                                    null
                                                }
                                                {this.state.userDetails.status === "2"
                                                    ?
                                                    <div className="serviceStatus_inactive px-2 col-md-5 p-0 m-0 text-center mx-auto" style={{ height: 23, width: '34%' }} >
                                                        {this.props.locales.suspendedServiceStatusInOverview}
                                                    </div>
                                                    :
                                                    null
                                                }
                                                {this.state.userDetails.status === "3"
                                                    ?
                                                    <div className="serviceStatus_inactive px-2 col-md-5 p-0 m-0 text-center mx-auto" style={{ height: 23, minWidth: '34%' }} >{this.props.locales.preTerminatedServiceStatusInOverview}</div>
                                                    :
                                                    null
                                                }
                                                {this.state.userDetails.status === "4"
                                                    ?
                                                    <div className="serviceStatus_inactive px-2 col-md-5 p-0 m-0 text-center mx-auto" style={{ height: 23, width: '34%' }} >{this.props.locales.terminatedServiceStatusInOverview}</div>
                                                    :
                                                    null
                                                }
                                            </div>
                                            <div className="d-flex justify-content-between col-md-12 p-0 m-0 row">
                                                <div className="col-md-9 p-0 m-0" style={{ color: '#a3b4bc', fontSize: 14, fontWeight: 500 }}><img src={phone} alt="" /></div>
                                            </div>
                                            <div className="mt-1" style={{ color: '#231F20', fontWeight: 500, fontSize: 30 }}>
                                                {this.state.userDetails.service_name}
                                            </div>
                                            <div className='d-flex justify-content-between align-items-center'>
                                                <div className='mt-3'> 
                                                    <div className="labelsInMyAccountContainer">{this.props.locales.serviceIdLabelForServiceBoxInOverview}</div>
                                                    <div className="valuesInMyAccountContainer">
                                                        {this.state.userDetails.service_id}
                                                    </div>
                                                </div>
                                                { this.state.connectionType === "2" && this.state.enablePayGo === "true" ?
                                                <div className='mt-3'>
                                                <div className="pr-2" style={{fontWeight: 600}}>{this.props.locales.payGoSecHeading}</div>
                                                <Toggle
                                                    checked={this.state.payGoStatus}
                                                    className='custom-classname'
                                                    icons={false}
                                                    onChange={(event) => this.handleInputValueChangeToggle("payGoStatus", event, "checkbox")} />
                                                </div>
                                                : null }
                                               
                                            </div>
                                            

                                        </div>
                                    </div>

                                </div>
                                {this.state.isPrepaidService ?
                                    <div className="col-md-6 p-0" >
                                        <div className="myAccountHeadingText" style={{ visibility: 'hidden', height: 25 }}>{this.props.locales.serviceOfferHeadingInManageService}</div>
                                        <div className="col-md-12 myAccountServicesBox py-2 mx-auto" style={{ height: 185 }}>
                                            <div className="">
                                                <span style={{ color: '#231F20', fontWeight: 500, fontSize: 14 }}>{this.props.locales.mainBalanceHeadingPrepaidService}</span>
                                            </div>
                                            <div className="mt-1 d-flex">
                                                <span style={{ color: '#231F20', fontWeight: 500 }} className="d-flex">
                                                    <span>{Constants.dollarSign}</span><span style={{ lineHeight: '33px', fontSize: 30 }}>{this.state.maBalance}</span><span>{this.state.maBalance_sup}</span>
                                                </span>
                                                {parseFloat(this.state.discountAmount) > 0
                                                    ?
                                                    <span style={{ paddingLeft: 5 }} style={{ cursor: 'pointer' }}>
                                                        <button className="tooltipContainer" id="priceInfoTooltip"><img src={infoIcon} alt="" /></button>
                                                    </span>
                                                    :
                                                    <button className="tooltipContainer d-none" id="priceInfoTooltip"></button>
                                                }

                                            </div>
                                            <Tooltip placement="bottom" innerClassName="tooltip-inner" isOpen={this.state.isPriceInfoTooltipOpen} target="priceInfoTooltip" toggle={() => { this.setState({ isPriceInfoTooltipOpen: !this.state.isPriceInfoTooltipOpen }) }}>
                                           <div className="col-md-12 row mx-auto p-2">
                                           <div className="col-md-12 py-1">{this.props.locales.priceDetailsInPriceInfoTooltip}</div>
                                           <div className="col-md-12 row justify-content-between mx-auto p-0 m-0 pb-1" style={{ color: '#B3B3B3', fontSize: 11, fontWeight: 500 }}>
                                               <span>{this.props.locales.BasepriceInPriceInfoTooltip}</span>
                                               <span style={{textDecoration:'line-through'}}>{Constants.dollarSign}{this.state.basePlanDetailsObj.basePlanPrice}</span>
                                           </div>
                                           <div className="col-md-12 row justify-content-between mx-auto p-0 m-0 pt-1 pb-2" style={{ color: '#B3B3B3', fontSize: 11, fontWeight: 500 }}>
                                               <span>{this.state.basePlanDetailsObj.discountName}</span>
                                               <span style={{textDecoration:'line-through'}}>{Constants.dollarSign}{this.state.basePlanDetailsObj.discountAmount}</span>
                                           </div>
                                           <div className="col-md-12 row mx-auto p-0 m-0" style={{borderTop:'1px dashed #B3B3B3'}}></div>
                                           <div className="col-md-12 row justify-content-between mx-auto p-0 m-0 py-1">
                                               <span>{this.props.locales.totalHeadingInPriceTooltip}</span>
                                               <span>{Constants.dollarSign}{this.state.basePlanDetailsObj.activePlanAmount}.{this.state.basePlanDetailsObj.activePlanDecimal}</span>
                                           </div>
                                           </div>
                                        </Tooltip>

                                            {this.state.lastRechargeDate !== "" ?
                                                <div className="labelsInMyAccountContainer mt-3">
                                                    <div className="mt-2" style={{ color: '#231F20', fontSize: 14, fontWeight: 400 }}>
                                                        {this.props.locales.lastRechargeDateHeadingOnPrepaidService}: <span style={{ fontWeight: 600 }}>{this.state.lastRechargeDate}</span>
                                                    </div>
                                                </div>
                                                : <div className="pt-2" style={{ color: '#231F20', fontSize: 22, fontWeight: 500 }}>
                                                {this.state.basePlanDetailsObj.activePlanName}
                                            </div>  
                                            }
                                            {/* hiding change plan button */}
                                            {this.state.changePlanStatus == "1" ?
                                                <div className="mt-3 mb-2" style={{ position: 'absolute', bottom: 0, right: 10 }}>
                                                    <button className="btn  chngPlanButton" onClick={() => { this.generalButtonsClicked('changePlan') }}>&nbsp;&nbsp;{this.props.locales.changePlanBtnTextInManageService}&nbsp;&nbsp;</button>
                                                </div>
                                            : null}
                                        </div>
                                    </div>
                                    :
                                    <div className="col-md-6 p-0" >
                                        <div className="myAccountHeadingText" style={{ visibility: 'hidden', height: 25 }}>{this.props.locales.serviceOfferHeadingInManageService}</div>
                                        <div className="col-md-12 myAccountServicesBox py-2 mx-auto d-md-block d-none" style={{ height: 185 }}>
                                            <div className="">
                                                <span style={{ color: '#231F20', fontWeight: 500, fontSize: 14 }}>{this.props.locales.currentActiveOfferHeadingInManageService}</span>
                                            </div>
                                            <div className="mt-1 d-flex">
                                    { parseFloat(this.state.basePlanDetailsObj.activePlanAmount) > 0  ?
                                        <span style={{ color: '#231F20', fontWeight: 500 }} className="d-flex">
                                            <span>{Constants.dollarSign}</span><span style={{ lineHeight: '33px', fontSize: 30}}>{this.state.basePlanDetailsObj.activePlanAmount}</span>
                                            <span>{this.state.basePlanDetailsObj.activePlanDecimal}
                                                {this.state.basePlanDetailsObj.isRecurring ? this.props.locales.perMonthTextForAmount : "" }
                                            </span>
                                        </span>
                                    : null }
                                        { parseFloat(this.state.basePlanDetailsObj.discountAmount) > 0 
                                        ?
                                            <span style={{ paddingLeft: 5, cursor: 'pointer'  }}>
                                                <button className="tooltipContainer" id="priceInfoTooltip"><img src={infoIcon} alt="" /></button>
                                            </span>
                                        :
                                            <button className="tooltipContainer d-none" id="priceInfoTooltip"></button>
                                        }
                                      
                                    </div>
                                    <Tooltip placement="bottom" innerClassName="tooltip-inner" isOpen={this.state.isPriceInfoTooltipOpen} target="priceInfoTooltip" toggle={() => { this.setState({ isPriceInfoTooltipOpen: !this.state.isPriceInfoTooltipOpen }) }}>
                                       <div className="col-md-12 row mx-auto p-2">
                                       <div className="col-md-12 py-1">{this.props.locales.priceDetailsInPriceInfoTooltip}</div>
                                       <div className="col-md-12 row justify-content-between mx-auto p-0 m-0 pb-1" style={{ color: '#B3B3B3', fontSize: 11, fontWeight: 500 }}>
                                           <span>{this.props.locales.BasepriceInPriceInfoTooltip}</span>
                                           <span style={{textDecoration:'line-through'}}>{Constants.dollarSign}{this.state.basePlanDetailsObj.basePlanPrice}</span>
                                       </div>
                                       <div className="col-md-12 row justify-content-between mx-auto p-0 m-0 pt-1 pb-2" style={{ color: '#B3B3B3', fontSize: 11, fontWeight: 500 }}>
                                           <span>{this.state.basePlanDetailsObj.discountName}</span>
                                           <span style={{textDecoration:'line-through'}}>{Constants.dollarSign}{this.state.basePlanDetailsObj.discountAmount}</span>
                                       </div>
                                       <div className="col-md-12 row mx-auto p-0 m-0" style={{borderTop:'1px dashed #B3B3B3'}}></div>
                                       <div className="col-md-12 row justify-content-between mx-auto p-0 m-0 py-1">
                                           <span>{this.props.locales.totalHeadingInPriceTooltip}</span>
                                           <span>{Constants.dollarSign}{this.state.basePlanDetailsObj.activePlanAmount}.{this.state.basePlanDetailsObj.activePlanDecimal}</span>
                                       </div>
                                       </div>
                                    </Tooltip>

                                            <div className="labelsInMyAccountContainer mt-3">
                                                {this.state.serviceContractDateFrom === ""
                                                    ?
                                                    <div className="mt-4" style={{ color: '#231F20', fontSize: 22, fontWeight: 500 }}>
                                                        {this.state.activePlanName}
                                                    </div>
                                                    :
                                                    <span> {this.props.locales.contractLabelInManageService} <span className="valuesInMyAccountContainer">{this.state.serviceContractDateFrom} - {this.state.serviceContractDateTo}</span></span>
                                                }
                                            </div>
                                            {/* {this.state.changePlanStatus === "1" ?
                                                <div className="mt-3 mb-2" style={{ position: 'absolute', bottom: 0, right: 10 }}>
                                                    <button className="btn  chngPlanButton" onClick={() => { this.generalButtonsClicked('changePlan') }}>&nbsp;&nbsp;{this.props.locales.changePlanBtnTextInManageService}&nbsp;&nbsp;</button>
                                                </div>
                                                : null} */}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    {this.state.isPrepaidService ?
                        <div className="col-lg-4 mt-4">
                            <div className="p-sm-3 p-0 quickLinksOuterContainer">
                                <div className="myAccountHeadingText">{this.props.locales.myAccountOverViewPartQuickLinksTxt}</div>
                                <div className="col-md-12 d-flex row m-0 p-0 justify-content-between">
                                    <div className="col-md-6 mt-2 myAccountMyQuickLinksBox" onClick={() => { this.quickLinkClicked("fnf") }}>
                                        <Button color="link" className="logoutButton mt-1 w-100" ><img alt="" src={SwitchAccount} /></Button>
                                        <div className="myAccountHeadingText_ d-none d-md-block" style={{ textAlign: "center", fontSize: 13, color: '#231F20' }}>{this.props.locales.quickLinksFandFWeb}</div>
                                        <div className="myAccountHeadingText_ d-block d-md-none" style={{ textAlign: "center", fontSize: 13, color: '#231F20' }}>{this.props.locales.quickLinksFandFMob}</div>
                                    </div>
                                    {this.state.rechargeStatus == 1 ?
                                        <div className="col-md-6 mt-2 myAccountMyQuickLinksBox" onClick={() => { this.quickLinkClicked("recharge") }}>
                                            <Button color="link" className="logoutButton mt-1 w-100"><img alt="" src={Recharge} /></Button>
                                            <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 13, color: '#231F20' }}>{this.props.locales.quickLinksRechargeOrVoucher}</div>
                                        </div>
                                        :
                                        <div className="col-md-6 mt-2 myAccountMyQuickLinksBox" style={{ cursor: 'not-allowed' }}>
                                            <Button color="link" className="logoutButton mt-1 w-100" style={{ cursor: 'not-allowed' }}><img alt="" src={Recharge} /></Button>
                                            <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 13, color: '#231F20' }}>{this.props.locales.quickLinksRechargeOrVoucher}</div>
                                        </div>
                                    }
                                    {this.state.settingsStatus == 1 ?
                                        <div className="col-md-6 mt-3 myAccountMyQuickLinksBox">
                                            <Link to="/settings" style={{ color: '#000', textDecoration: 'none' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" ><img alt="" src={SettingsAccount} /></Button>
                                                <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSettingsBtn}</div>
                                            </Link>
                                        </div>
                                        :
                                        <div className="col-md-6 mt-3 myAccountMyQuickLinksBox" style={{ cursor: 'not-allowed' }}>
                                            <Link style={{ color: '#000', textDecoration: 'none', cursor: 'not-allowed' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" style={{ cursor: 'not-allowed' }}><img alt="" src={SettingsAccount} /></Button>
                                                <div className="myAccountHeadingText_" style={{ cursor: 'not-allowed', textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSettingsBtn}</div>
                                            </Link>
                                        </div>
                                    }
                                    {this.state.serviceCenterStatus == 1 ?
                                        <div className="col-md-6 mt-3 myAccountMyQuickLinksBox">
                                            <Link to="/serviceCenter" style={{ color: '#000', textDecoration: 'none' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" ><img alt="" src={Support} /></Button>
                                                <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSupportBtn}</div>
                                            </Link>
                                        </div>
                                        :
                                        <div className="col-md-6 mt-3 myAccountMyQuickLinksBox" style={{ cursor: 'not-allowed' }}>
                                            <Link style={{ color: '#000', textDecoration: 'none', cursor: 'not-allowed' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" style={{ cursor: 'not-allowed' }} ><img alt="" src={Support} /></Button>
                                                <div className="myAccountHeadingText_" style={{ cursor: 'not-allowed', textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSupportBtn}</div>
                                            </Link>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        <div className="col-lg-4 mt-4">
                            <div className="p-sm-3 p-0 quickLinksOuterContainer">
                                <div className="myAccountHeadingText">{this.props.locales.myAccountOverViewPartQuickLinksTxt}</div>
                                <div className="col-md-12 d-flex row m-0 p-0 justify-content-between">
                                    {this.state.billsAndPaymentStatus == 1 ?
                                        <div className="col-md-6 mt-2 myAccountMyQuickLinksBox">
                                            <Link to="/billingAndPayments" style={{ color: '#000', textDecoration: 'none' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100"><img alt="" src={BillAccount} /></Button>
                                                <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartBillsBtn}</div>
                                            </Link>
                                        </div>
                                        :
                                        <div className="col-md-6 mt-2 myAccountMyQuickLinksBox" style={{ cursor: 'not-allowed' }}>
                                            <Link to="" style={{ color: '#000', textDecoration: 'none', cursor: 'not-allowed' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" style={{ cursor: 'not-allowed' }}><img alt="" src={BillAccount} /></Button>
                                                <div className="myAccountHeadingText_" style={{ cursor: 'not-allowed', textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartBillsBtn}</div>
                                            </Link>
                                        </div>
                                    }
                                    <div className="col-md-6 mt-2 myAccountMyQuickLinksBox" onClick={() => { this.quickLinkClicked("fnf") }}>
                                        <Button color="link" className="logoutButton mt-1 w-100" ><img alt="" src={SwitchAccount} /></Button>
                                        <div className="myAccountHeadingText_ d-none d-md-block" style={{ textAlign: "center", fontSize: 13, color: '#231F20' }}>{this.props.locales.quickLinksFandFWeb}</div>
                                        <div className="myAccountHeadingText_ d-block d-md-none" style={{ textAlign: "center", fontSize: 13, color: '#231F20' }}>{this.props.locales.quickLinksFandFMob}</div>
                                    </div>
                                    {this.state.settingsStatus == 1 ?
                                        <div className="col-md-6 mt-3 myAccountMyQuickLinksBox">
                                            <Link to="/settings" style={{ color: '#000', textDecoration: 'none' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" ><img alt="" src={SettingsAccount} /></Button>
                                                <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSettingsBtn}</div>
                                            </Link>
                                        </div>
                                        :
                                        <div className="col-md-6 mt-3 myAccountMyQuickLinksBox" style={{ cursor: 'not-allowed' }}>
                                            <Link style={{ color: '#000', textDecoration: 'none', cursor: 'not-allowed' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" style={{ cursor: 'not-allowed' }}><img alt="" src={SettingsAccount} /></Button>
                                                <div className="myAccountHeadingText_" style={{ cursor: 'not-allowed', textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSettingsBtn}</div>
                                            </Link>
                                        </div>
                                    }
                                    {this.state.serviceCenterStatus == 1 ?
                                        <div className="col-md-6 mt-3 myAccountMyQuickLinksBox">
                                            <Link to="/serviceCenter" style={{ color: '#000', textDecoration: 'none' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" ><img alt="" src={Support} /></Button>
                                                <div className="myAccountHeadingText_" style={{ textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSupportBtn}</div>
                                            </Link>
                                        </div>
                                        :
                                        <div className="col-md-6 mt-3 myAccountMyQuickLinksBox" style={{ cursor: 'not-allowed' }}>
                                            <Link style={{ color: '#000', textDecoration: 'none', cursor: 'not-allowed' }}>
                                                <Button color="link" className="logoutButton mt-1 w-100" style={{ cursor: 'not-allowed' }} ><img alt="" src={Support} /></Button>
                                                <div className="myAccountHeadingText_" style={{ cursor: 'not-allowed', textAlign: "center", fontSize: 14, color: '#231F20' }}>{this.props.locales.myAccountOverViewPartSupportBtn}</div>
                                            </Link>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>

                <div className="col-md-12 px-3">
                    <div className="col-md-12">
                        <div className="col-md-12 ml-2 mt-4 mb-3 p-0 mx-auto" style={{ color: '#58595B', fontWeight: 500, fontSize: 18, borderBottom: '1px solid #d6d6d6' }}>
                            {this.props.locales.offersSectionHeadingInManageService}
                        </div>
                    </div>

                  
                <div className="col-md-12 mb-3">
                <div className="col-md-5 row p-0 m-0">
                        <div className="activePlanContainer px-3 pb-2" style={{ backgroundColor: '#FFFFFF',width: '100%', minHeight: 160, border: '1px solid rgba(2,133,202,0.2)' }}>
                            <div className="col-md-12" style={{ height: 20 }}>
                                <div className="selectedBadge p-0">
                                    {this.props.locales.currentServiceSectionHeadingInManageService}
                                </div>
                            </div>
                            <div className="py-2">
                            <div className="d-flex justify-content-between col-md-12 p-0 mb-2">
                                <div className="col-md-2 mt-2 p-0"><img src={phoneDisabled} alt="" /></div>
                                <div className="col-md-10 text-right p-0 d-flex justify-content-end mt-2" style={{ color: '#231F20' }}>
                                { parseFloat(this.state.basePlanDetailsObj.activePlanAmount) > 0  ?
                                        <span style={{ color: '#231F20', fontWeight: 500 }} className="d-flex">
                                            <span>{Constants.dollarSign}</span><span style={{ lineHeight: '32px', fontSize: 28}}>{this.state.basePlanDetailsObj.activePlanAmount}</span><span>{this.state.basePlanDetailsObj.activePlanDecimal}{this.props.locales.perMonthTextForAmount}</span>
                                        </span>
                                    : null }
                                    { parseFloat(this.state.basePlanDetailsObj.discountAmount) > 0 
                                    ?
                                        <span style={{ paddingLeft: 5 }} style={{ cursor: 'pointer' }}>
                                            <button className="tooltipContainer" id="priceInfoTooltip"><img src={infoIcon} alt="" /></button>
                                        </span>
                                    : 
                                        <button className="tooltipContainer d-none" id="priceInfoTooltip"></button>
                                     }
                                </div>
                            </div>
                            <div className="d-flex justify-content-between pr-sm-3 pr-0">
                                <div className="col-md-9 nameContainer p-0" style={{ color: '#231F20', fontWeight: 500, fontSize: 18 }}>{this.state.basePlanDetailsObj.activePlanName}</div>
                                {/* {parseFloat(this.state.basePlanDetailsObj.discountAmount) > 0 ?
                                    <span className="col-md-3 p-0 m-0" style={{fontSize:10,color:'#FF8F18',textDecoration:'line-through'}}>
                                        <span>{Constants.dollarSign}</span><span style={{ lineHeight: '10px', fontSize: 14 }}>{this.state.basePlanDetailsObj.discountAmount}</span><span>{this.state.basePlanDetailsObj.discountAmountDecimal}{this.props.locales.perMonthTextForAmount}</span>
                                    </span>
                                    :
                                    null
                                } */}
                            </div>
                            <div className="col-md-12 p-0 labelsInMyAccountContainer">{this.props.locales.offerDescriptionLabelInManageService} <span className="valuesInMyAccountContainer">{this.state.basePlanDetailsObj.activePlanDesc}</span></div>
                            <div className="col-md-12 p-0 labelsInMyAccountContainer">{this.props.locales.activationDateLabelInManageService} <span className="valuesInMyAccountContainer">{this.state.basePlanDetailsObj.activationDate}</span></div>
                            {/* { this.state.connectionType !== "2"? 
                                <div className="col-md-12 p-0 labelsInMyAccountContainer">{this.props.locales.expiryDateLabelInManageService} <span className="valuesInMyAccountContainer">{this.state.basePlanDetailsObj.postpaidExpiryDate}</span></div>
                            : null } */}
                       </div>

                         {/* usageReport */}
                         {this.state.basePlanDetailsObj.benefits.length > 0 ?
                        <div className="">
                                <div className="d-flex justify-content-between" style={{fontSize:12,color:'#0049A5'}}>
                                    <div>{this.props.locales.usageSecHeadingInAllAddons}</div>
                                    <div style={{fontWeight:500}}>{used}/{this.state.basePlanDetailsObj.benefits[0].initialVal} {this.state.basePlanDetailsObj.benefits[0].unit}</div>
                                </div>
                                <div className="progress my-1" style={{height: 10}}>
                                    <div className="progress-bar" role="progressbar" style={{width: widthFromVar,backgroundColor: '#0049A5'}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"> </div>
                                </div>
                                {/* <div style={{fontSize:10, color: '#0049A5',fontWeight:500}}>{widthFromVar} used</div> */}
                                <div className='d-flex justify-content-between align-items-center flex-lg-row flex-column'>
                                <div className="row justify-content-center py-2 col-md-12" style={{ color: '#407CCA', fontWeight: 600, fontSize: 12, cursor: 'pointer'}}
                                    onClick={(event) => { this.allUsageInfoClicked("","basePlan",event) }}>
                                    {this.props.locales.viewAllUsageInfoSectionHeadingGsm}
                                </div>
                                {/* {this.state.changePlanStatus  === "1" ?
                                    <div className="my-2 text-right">
                                        <button className="btn  chngPlanButton" onClick={() => { this.generalButtonsClicked('changePlan') }}>&nbsp;&nbsp;{this.props.locales.changePlanBtnTextInManageService}&nbsp;&nbsp;</button>
                                    </div>
                                : null} */}
                                </div>
                        </div>
                         
                        : null }
                    
                        </div>
                    </div>
                </div>
                </div>

                <div className="col-md-12 px-3">
                <div className="col-md-12">
                    <div className="col-md-12 ml-2 mt-4 mb-3 p-0 mx-auto row align-items-center" style={{ color: '#58595B', fontWeight: 500, fontSize: 18, borderBottom: '1px solid #d6d6d6' }}>
                        <div className='col-md-9 p-0'>{this.props.locales.currentAddonsSectionHeading}</div>
                        <div className="col-md-3 p-0">
                                <div className="form-group col-md-12 p-0 mb-1">
                                    <div className="input-group">
                                        <input type="text" className="form-control formGroup_value input_data_"
                                            name="addonSearchName" autoComplete="off" placeholder='Search' value={this.state.moreInfo_name} style={{border: '1px solid #EAEDF0',borderRadius:4, borderRight: 0, boxShadow: 'unset', outline: 'none'}}
                                            onChange={(event) => {
                                                this.handleInputValueChange("addonSearchName", event.target.value)
                                            }}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text" style={{ backgroundColor: '#ffffff', borderLeft: 0, color: '#d6d6d6' ,border: '1px solid #EAEDF0'}}>
                                                    <img src={searchIcon} alt="" /> 
                                            </span>
                                        </div>
                                    </div>
                                </div>
                         </div>
                    </div>
                </div>

                <div className="col-md-12 row m-0 mx-auto p-0" style={{minHeight:180}}>
                        {this.populateAddons()}
                        {this.state.addAddonsStatus == 1 ?
                            <div className="col-md-4 row p-0 m-0 pb-3 justify-content-center">
                                <div className="d-flex justify-content-center align-items-center" style={{ borderRadius: 6, backgroundColor: 'rgba(255,255,255,0)', border: '1px solid #A3B4BC', minHeight: 144, width: '93%' }}>
                                    <div className="d-flex justify-content-center p-3" onClick={() => { this.generalButtonsClicked("addAddon") }} style={{ cursor: 'pointer' }}>
                                        <div className="addressDetailsDiv mt-2 p-2 d-flex flex-column justify-content-center align-items-center" style={{ textAlign: 'center' }}>
                                            <div style={{ backgroundColor: '#EAECEF', height: 56, width: 56, borderRadius: 27, paddingTop: 15 }}><FaPlus color='#231F20' className="plusIcon" /></div>
                                            <div style={{ color: '#231F20', fontSize: 16, paddingTop: 10 }}>{this.props.locales.addAddonButtonTextInManageService}</div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            : null}

                    </div>
                </div>

                <div id="myAccountInternetCallHistoryPart" className="col-md-12 my-4 px-3">
                    <div className="mainHeading mb-3 col-md-12">{this.props.locales.transactionDetailsSectionHeadingInManageService}</div>
                    <div className="col-md-12 row mx-auto">
                        <div className="form-group col-md-2 pl-0">
                            <label className="formGroup_label">Service Type</label>
                            <div className="input-group">
                                <select required className="form-control mandatoryField input_data custom-select mr-sm-2 formGroup_value"
                                        value={this.state.serviceType}
                                        onChange={(event) => this.handleInputValueChange("serviceType", event.target.value)}>
                                        {this.state.serviceTypeTypeArray.map((item, key) => {
                                            return (
                                                <option key={key} value={item.id}>{item.value}</option>
                                            )
                                        })
                                        }
                                </select>
                            </div>
                            <div className="errorDesc"></div>
                        </div>

                        <div className="form-group col-md-2 pl-0">
                            <label className="formGroup_label">{this.props.locales.transactionHistoryFromDateLabel}</label>
                            <div className="input-group">
                                <DatePicker
                                    dateFormat="MM/dd/yyyy" disabledKeyboardNavigation maxDate={new Date()}
                                    className="form-control formGroup_value mandatoryField_ input_data_ specialCharactersAllowed_"
                                    selected={this.state.transactionHistoryDateFrom}
                                    onChange={(event) => this.handleInputValueChange("transactionHistoryDateFrom", event)}
                                />
                            </div>
                            <div className="errorDesc"></div>
                        </div>
                        <div className="form-group col-md-2 pl-0">
                            <label className="formGroup_label">{this.props.locales.transactionHistoryToDateLabel}</label>
                            <div className="input-group">
                                <DatePicker
                                    popperProps={{
                                        positionFixed: true // use this to make the popper position: fixed
                                    }}
                                    dateFormat="MM/dd/yyyy" disabledKeyboardNavigation
                                    maxDate={new Date(this.state.maxDateForTransactionHistory)} minDate={this.state.transactionHistoryDateFrom}
                                    className="form-control formGroup_value mandatoryField_ input_data_ specialCharactersAllowed_"
                                    selected={this.state.transactionHistoryDateTo}
                                    onChange={(event) => this.handleInputValueChange("transactionHistoryDateTo", event)}
                                />
                            </div>
                            <div className="errorDesc"></div>
                        </div>
                        <div className="form-group col-md-2 pl-0">
                            <label className="formGroup_label" style={{ visibility: 'hidden' }}>Search</label>
                            <div className="input-group">
                                <button className="btn chngPlanButton" style={{width: '100%' }} onClick={() => { this.fetchTransactionHistory() }}>&nbsp;&nbsp;{this.props.locales.transactionSearchTxtInGsm}&nbsp;&nbsp;</button>
                            </div>
                            <div className="errorDesc"></div>
                        </div>
                    </div>
              
                    <div className="col-md-12 pb-1 transactionHistoryOuterDiv" ref="transactionHistoryForGsmPart" id="transactionHistoryForGsmPart" style={{ overflow: 'auto', backgroundColor: '#ffffff', boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)', borderRadius: 6 }}>
                        <TableComponent
                            headerArray={[
                                {
                                    key: "Service",
                                    label: "Service"
                                },
                                {
                                    key: "Date and time",
                                    label: "Date and time"
                                },
                                {
                                    key: "Charge",
                                    label: "Charge"
                                },
                                {
                                    key: "Duration",
                                    label: "Duration"
                                },
                                {
                                    key: "Balance",
                                    label: "Balance"
                                },
                                {
                                    key: "MSISDN",
                                    label: this.props.locales.msisdnTableHeaderInTransaction
                                },
                                {
                                    key: "B party",
                                    label: this.props.locales.bPartyTableHeaderInTransaction
                                },
                                {
                                    key: "Status",
                                    label: "Status"
                                },
                                {
                                    key: "action",
                                    label: "View",
                                    formatter: (rowData, callback) => {
                                        return (
                                            <div>
                                                <img src={viewIcon} alt="" style={{ cursor: 'pointer' }} onClick={() => callback({ "type": "viewMore", "data": rowData })}/>
                                            </div>
                                        );

                                    }
                                }

                            ]}
                            payload={this.state.transactionHistoryPayload}
                            isSearchRequired={false}
                            noDataContentText={this.props.locales.noDataContentTextTransactionDetails}
                            limit={10}
                            paginationType="server"
                            tableUniqueId="transactionHistoryTable"
                            callback={this.transactionHistoryTableHandler}
                        />
                    </div>
                </div>

                <SliderModal
                    isVisible={this.state.isCallMeBackModalVisible}
                    uniqueModalReferenceId="callMeBack"
                    mainHeading={this.props.locales.mainHeadingInCallMeBackModal}
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    submitButtonText="Request"
                    callback={this.callMeBackModalHandler}
                >
                    <div className="col-md-12 px-2" style={{ height: '100%' }} id="callMeBackContainer">
                        <div className="col-md-12 pt-3">
                            <div className="form-group col-md-12 p-0 mb-1">
                                <label className="formGroup_label_new">{this.props.locales.enterPhoneNumInCallMeBackModal}</label>
                                <div className="d-flex">
                                    <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeContactNum"
                                        value={this.state.callMeBackVal}
                                        onChange={(event) => {
                                            this.handleInputValueChange("callMeBackVal", event.target.value)
                                            this.handleContactNumberOnBlur("callMeBackVal");
                                        }}
                                    />
                                </div>
                                <div className="errorDesc"></div>
                            </div>
                        </div>
                        {/* <div className="col-md-12" style={{ color: '#58595B', fontSize: 12, position: 'absolute', bottom: 0}}>
                            A charge of $1 will me made for call me back on every request, This will be deducted from the main balance after your next recharge.
                            </div> */}
                    </div>

                </SliderModal>

                <SliderModal
                    isVisible={this.state.isLoyaltySliderVisible}
                    uniqueModalReferenceId="loyaltyManagementModal"
                    mainHeading={this.state.tab === "transfer" ? "Transfer Loyalty Points" : "Transaction History"}
                    leftPartFlexValue={2.5}
                    rightPartFlexValue={2}
                    isResetButtonVisible={false}
                    isSubmitButtonVisible={this.state.tab === "transfer" ? true : false}
                    submitButtonText="Transfer"
                    cancelButtonText="Cancel"
                    contentPartBackgroundColor='#FFFFFF'
                    isButtonGroupRequired={true}
                    isPayNowButtonVisible={false}
                    amount="0"
                    callback={this.loyaltyTransferHandler}
                >
                    <div className="col-md-12" style={{ width: '88%', margin: 'auto' }}>
                        <div className="row m-0 pt-4 pb-0" style={{ borderBottom: '1px solid #d6d6d6' }}>
                            <div className={this.state.loyaltyTransferTab == true ? "tabHeader activeTabHeader" : "tabHeader"} onClick={() => { this.tablinkClickedForLoyalty('transfer') }} style={{ color: '#33495F' }}>{this.props.locales.transferPointsInGsmPart}</div>
                            <div className={this.state.transactionHistoryTab == true ? "tabHeader activeTabHeader" : "tabHeader"} onClick={() => { this.tablinkClickedForLoyalty('loyaltyTransactionHistory') }} style={{ color: '#33495F' }} >{this.props.locales.transactionHistoryInGsmPart}</div>
                        </div>

                        <div className="text-left pt-4">
                            <div style={{ fontSize: 14, fontWeight: 600, color: '#231F20' }}>{this.props.locales.totalRewardPointsHeadingInManageService} &nbsp;<span><button className="tooltipContainer" id="rewardPointsInfoTooltipInSlider"><img src={infoIcon} alt="" /></button></span></div>
                            <div style={{ fontSize: 30, color: '#231F20', fontWeight: 400 }}>{this.state.rewardPointsFromLMS}</div>
                            <Tooltip placement="top" isOpen={this.state.isRewardInfoTooltipOpenInSlider} target="rewardPointsInfoTooltipInSlider" toggle={() => { this.setState({ isRewardInfoTooltipOpenInSlider: !this.state.isRewardInfoTooltipOpenInSlider }) }}>
                                {this.props.locales.rewardPointsInfoTooltipText}
                            </Tooltip>
                        </div>

                        {this.state.tab === "transfer" ?
                            <div className="col-md-12 p-0" style={{ height: '100%' }}>
                                <div className="col-md-12 p-0">
                                    <div className="form-group col-md-12 p-0 mb-1">
                                        <label className="formGroup_label_new">{this.props.locales.enterPhoneNumInCallMeBackModal}</label>
                                        <div className="d-flex">
                                            <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeContactNum"
                                                value={this.state.phoneNumForLoyaltyTransfer}
                                                onChange={(event) => {
                                                    this.handleInputValueChange("phoneNumForLoyaltyTransfer", event.target.value)
                                                    this.handleContactNumberOnBlur("phoneNumForLoyaltyTransfer");
                                                }}
                                            />
                                        </div>
                                        <div className="errorDesc"></div>
                                    </div>
                                    <div className="col-md-12 row align-items-center justify-content-end py-2 p-0 mx-auto">
                                        <span className="pr-3" style={{ color: "#7E91A4", fontSize: 12 }}>
                                            {this.props.locales.transferInGsmpart}
                                        </span>
                                        <div className="rectangleBoxForUsage d-flex justify-content-center align-items-center">
                                            <input type="text" id="rangeSliderValForRewardPoints" value={this.state.rangeVal}
                                                name="rangeVal"
                                                onChange={(event) => this.initRange(event.target.value)}
                                                onChange={(event) => {
                                                    this.handleInputValueChange("rangeVal", event.target.value)
                                                    this.initRange(event.target.value)
                                                }}
                                                size="3" />
                                        </div>
                                    </div>
                                    <div>
                                        <input type="range" id="rangeSliderForRewardPoints" value={this.state.rangeVal} name="rangeInput" min="1" max={parseFloat(this.state.rewardPointsFromLMS)} step="1" onInput={(event) => this.initRange(event.target.value)} />
                                    </div>
                                </div>

                            </div>
                            : null}

                        {this.state.tab === "loyaltyTransactionHistory" ?

                            <div className="col-md-12 p-0">
                                <div className="col-md-12 p-0 pt-3" style={{ borderBottom: '1px solid #D6D6D6', fontSize: 18, fontWeight: 500, color: '#58595B' }}>{this.props.locales.allTransactionInGsmPart} </div>
                                <table className="table mt-3 text-center" style={{ outlineColor: '#eaedf0', marginTop: 10, border: '1px solid #eaedf0', borderShadow: 6, borderSizing: 'border-box', borderRadius: 6 }}>
                                    <thead style={{ backgroundColor: 'rgba(2,133,202,0.1)', color: '#231F20', fontSize: 14, border: '1px solid #eaedf0', borderRadius: 6, borderSizing: 'border-box' }}>
                                        <tr>
                                            <th>{this.props.locales.transactionTypeInGsmPart}</th>
                                            <th>{this.props.locales.dateInGsmPart}</th>
                                            <th>{this.props.locales.pointsInGsmPart}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loyaltyTransactionsPayload.data.map((item, key) => {
                                            return (
                                                <tr key={key}>
                                                    <td style={{ verticalAlign: 'middle' }}>
                                                        <div style={{ fontWeight: 500 }}>{item.transactionType}</div>
                                                        <div>{item.toServiceId}</div>
                                                    </td>
                                                    <td style={{ verticalAlign: 'middle' }}>{GeneralUtils.formatDateToStandardForm(item.date, "YYYY-MM-DD HH:mm:ss", "MM/DD/YYYY")}</td>
                                                    <td style={item.isCredited ? { color: '#36B07F', fontWeight: 500, verticalAlign: 'middle' } : { color: '#EE3124', fontWeight: 500, verticalAlign: 'middle' }}>{item.isCredited ? "+" : "-"}{item.loyaltyPoints}</td>
                                                </tr>
                                            )
                                        })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            : null}

                    </div>

                </SliderModal>

                <Modal isOpen={this.state.isViewUsageInfoModalVisible} size="md" centered>
                    <ModalBody style={{ height: '100%' }}>
                        <div style={{ zIndex: 1090 }}>
                            <div className=" text-center" style={{ marginBottom: 14, borderBottom: "1px solid #eaedf0", fontSize: 20, padding: "25px 25px 18px 25px", marginLeft: 32, marginRight: 32, fontWeight: 'bold', color: '#231F20' }}>{this.props.locales.usageDetailsModalHeadingGsm}</div>
                            <div style={{ width: '100%', height: '100%', padding: 20 }}>
                                {this.populateAllUsageDetails()}
                            </div>
                            <div className="text-right" style={{ paddingRight: 20 }}>
                                <div button className="btn paymentButton px-4 mb-3" style={{ color: "#0049A5", height: 40, boxSizing: 'border-box', border: '1px solid #0049AF', borderRadius: 4 }} onClick={() => { this.generalButtonsClicked("closeUsageModal") }}>
                                    {this.props.locales.closeButtonTxtInUsageModalGsm}
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                {this.state.isRechargeComponentVisible ?
                    <RechargeComponent amount=""
                        accountId={this.state.accountId}
                        billDueDate=""
                        billStartDate=""
                        billEndDate=""
                        billPeriod=""
                        billId=""
                        firstName={this.state.firstName}
                        lastName={this.state.lastName}
                        phoneNumber={this.state.phoneNumber}
                        emailId={this.state.emailId}
                        profileId={this.state.profileId}
                        serviceId={this.state.userDetails.service_id}
                        planId={this.state.planId}
                        callbackFromRechargeComponent={this.myCallback}
                    />
                    : null}

                {this.state.isReceiptModalVisible ?
                    <ReceiptComponent amount=""
                        isVisible={true}
                        content={this.props.locales.rechargeSuccessInReceiptModal}
                        transactionId={this.state.transactionId}
                        serviceId={this.state.userDetails.service_id}
                        finalRechargeAmount={this.state.finalRechargeAmount}
                        callback={this.receiptCallback}
                    />
                    : null}

                <SliderModal
                    isVisible={this.state.rewardsTermsAndConditionsVisible}
                    uniqueModalReferenceId="rewardsTermsAndConditions"
                    mainHeading="Terms And Conditions"
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    submitButtonText="Agree"
                    callback={this.rewardsTAndCModalHandler}
                >
                    <div className="col-md-12 px-2" style={{ height: '100%' }} >
                        <iframe title="" src="./rewardsTAndC.html" style={{ width: '100%', height: '100%', border: 'none' }} frameBorder="0"> </iframe>
                    </div>

                </SliderModal>

                <SliderModal
                    isVisible={this.state.redeemRewardsModalVisible}
                    uniqueModalReferenceId="redeemRewardsPlanList"
                    mainHeading="Redeem Rewards"
                    isResetButtonVisible={false}
                    leftPartFlexValue={1}
                    rightPartFlexValue={3}
                    isSubmitButtonVisible={false}
                    callback={this.redeemRewardsModalHandler}
                >
                    <div className="col-md-12 px-sm-4 px-2" style={{ height: '100%' }} >
                        <div className="col-md-12 p-0 py-2 mb-5" style={{ borderBottom: '1px solid #eaedf0', fontSize: 14, fontWeight: 600, color: '#231F20' }}>Total Reward Points <span style={{ fontSize: 20, fontWeight: 100 }}>|</span> {this.state.rewardPointsFromLMS}</div>

                        <div className="col-md-12 row m-0">
                            {this.populateAllRedeemablePlansInSlder()}
                        </div>
                    </div>

                </SliderModal>

                <SliderModal
                    isVisible={this.state.transactionsRewardsModalVisible}
                    uniqueModalReferenceId="redemptionHistory"
                    mainHeading="Redemption history"
                    isResetButtonVisible={false}
                    leftPartFlexValue={1}
                    rightPartFlexValue={3}
                    isSubmitButtonVisible={false}
                    callback={this.transactionsRewardsModalHandler}
                >
                    <div className="col-md-12 pb-1 transactionsOuterDiv" style={{ overflow: 'auto', backgroundColor: '#ffffff', boxShadow: '0 2px 4px 0 rgba(0,0,0,0.1)', borderRadius: 6 }} >
                        {/* <div className="col-md-12 p-0 py-2" style={{ borderBottom: '1px solid #eaedf0', fontSize: 14, fontWeight: 600, color: '#231F20' }}>Table</div> */}
                        <TableComponent
                            headerArray={[
                                {
                                    key: "date",
                                    label: "Transaction Date"
                                },
                                {
                                    key: "type",
                                    label: "Type",
                                    // formatter: (rowData, callback) => {
                                    //     var text = rowData.type;
                                    //     text = text.split("-")[0];
                                    //     var activity = rowData.activity;
                                    //     if(text.indexOf("Redeemed") > -1){
                                    //         text = text + " for "+activity;
                                    //     } 
                                    //     return (
                                    //         <div className="">
                                    //             {text}
                                    //         </div>
                                    //     )
                                    // }
                                },
                                {
                                    key: "loyalty_points",
                                    label: "Total Rewards Points"
                                },
                                {
                                    key: "expiry_points",
                                    label: "Expiry Points"
                                },
                                {
                                    key: "expiry_date",
                                    label: "Expiry Date"
                                }
                            ]}
                            payload={this.state.rewardsTransactionsData}
                            isSearchRequired={true}
                            noDataContentText="No Rewards Transactions Found"
                            limit={5}
                            tableUniqueId="rewardsTransactionsTable"
                            callback={this.rewardsTransactionsTableHandler}
                        />
                    </div>
                </SliderModal>

                <SliderModal
                    isVisible={this.state. isTransactionHistoryModalVisible}
                    uniqueModalReferenceId="transactionHistory"
                    mainHeading={this.props.locales.transactionHistorySliderHeading}
                    leftPartFlexValue={2}
                    rightPartFlexValue={1}
                    isResetButtonVisible={false}
                    isSubmitButtonVisible={false}
                    callback={this.transactionHistoryModalHandler}
                >
                    <div className="col-md-12" id="">
                        <table className="table">
                            {this.populateTransactionHistoryDetailsInSlider()}
                        </table>

                    </div>
                </SliderModal>


            </div>
        );
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        feasibilityResposnse: state.feasibilityResposnse,
        userDetails: state.userDetails,
        configurationValues: state.configurationValues,
        registerDetails: state.registerDetails,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setSwitchAccountModalTrue: function () {
            dispatch(setSwitchAccountModalTrue());
        },
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        },
        setfeasibilityResposne: function (key, payload) {
            dispatch(setfeasibilityResposne(key, payload));
        }, setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        }
    }
}

const MyAccountVoicePartComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MyAccountVoicePartComponent)

export default MyAccountVoicePartComponentContainer;
